"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3369],{

/***/ 27739:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "t": function() { return /* binding */ cn; }
});

// UNUSED EXPORTS: n

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(48417);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_sliced_to_array.mjs
var _sliced_to_array = __webpack_require__(99758);
;// CONCATENATED MODULE: ../atoms/lib/chunks/vendor-styling-ngocy1lirv3frm2y.js
"use client";



//#region ../../node_modules/.pnpm/clsx@2.1.1/node_modules/clsx/dist/clsx.mjs
function r(e) {
    var t, f, n = "";
    if ("string" == typeof e || "number" == typeof e) n += e;
    else if ("object" == typeof e) if (Array.isArray(e)) {
        var o = e.length;
        for(t = 0; t < o; t++)e[t] && (f = r(e[t])) && (n && (n += " "), n += f);
    } else for(f in e)e[f] && (n && (n += " "), n += f);
    return n;
}
function clsx() {
    for(var e, t, f = 0, n = "", o = arguments.length; f < o; f++)(e = arguments[f]) && (t = r(e)) && (n && (n += " "), n += t);
    return n;
}
//#endregion
//#region ../../node_modules/.pnpm/tailwind-merge@3.6.0/node_modules/tailwind-merge/dist/bundle-mjs.mjs
/**
* Concatenates two arrays faster than the array spread operator.
*/ var concatArrays = function(array1, array2) {
    var combinedArray = new Array(array1.length + array2.length);
    for(var i = 0; i < array1.length; i++)combinedArray[i] = array1[i];
    for(var i1 = 0; i1 < array2.length; i1++)combinedArray[array1.length + i1] = array2[i1];
    return combinedArray;
};
var createClassValidatorObject = function(classGroupId, validator) {
    return {
        classGroupId: classGroupId,
        validator: validator
    };
};
var createClassPartObject = function() {
    var nextPart = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : /* @__PURE__ */ new Map(), validators = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, classGroupId = arguments.length > 2 ? arguments[2] : void 0;
    return {
        nextPart: nextPart,
        validators: validators,
        classGroupId: classGroupId
    };
};
var CLASS_PART_SEPARATOR = "-";
var EMPTY_CONFLICTS = [];
var ARBITRARY_PROPERTY_PREFIX = "arbitrary..";
var createClassGroupUtils = function(config) {
    var classMap = createClassMap(config);
    var conflictingClassGroups = config.conflictingClassGroups, conflictingClassGroupModifiers = config.conflictingClassGroupModifiers;
    var getClassGroupId = function(className) {
        if (className.startsWith("[") && className.endsWith("]")) return getGroupIdForArbitraryProperty(className);
        var classParts = className.split(CLASS_PART_SEPARATOR);
        return getGroupRecursive(classParts, classParts[0] === "" && classParts.length > 1 ? 1 : 0, classMap);
    };
    var getConflictingClassGroupIds = function(classGroupId, hasPostfixModifier) {
        if (hasPostfixModifier) {
            var modifierConflicts = conflictingClassGroupModifiers[classGroupId];
            var baseConflicts = conflictingClassGroups[classGroupId];
            if (modifierConflicts) {
                if (baseConflicts) return concatArrays(baseConflicts, modifierConflicts);
                return modifierConflicts;
            }
            return baseConflicts || EMPTY_CONFLICTS;
        }
        return conflictingClassGroups[classGroupId] || EMPTY_CONFLICTS;
    };
    return {
        getClassGroupId: getClassGroupId,
        getConflictingClassGroupIds: getConflictingClassGroupIds
    };
};
var getGroupRecursive = function(classParts, startIndex, classPartObject) {
    if (classParts.length - startIndex === 0) return classPartObject.classGroupId;
    var currentClassPart = classParts[startIndex];
    var nextClassPartObject = classPartObject.nextPart.get(currentClassPart);
    if (nextClassPartObject) {
        var result = getGroupRecursive(classParts, startIndex + 1, nextClassPartObject);
        if (result) return result;
    }
    var validators = classPartObject.validators;
    if (validators === null) return;
    var classRest = startIndex === 0 ? classParts.join(CLASS_PART_SEPARATOR) : classParts.slice(startIndex).join(CLASS_PART_SEPARATOR);
    var validatorsLength = validators.length;
    for(var i = 0; i < validatorsLength; i++){
        var validatorObj = validators[i];
        if (validatorObj.validator(classRest)) return validatorObj.classGroupId;
    }
};
/**
* Get the class group ID for an arbitrary property.
*
* @param className - The class name to get the group ID for. Is expected to be string starting with `[` and ending with `]`.
*/ var getGroupIdForArbitraryProperty = function(className) {
    return className.slice(1, -1).indexOf(":") === -1 ? void 0 : function() {
        var content = className.slice(1, -1);
        var colonIndex = content.indexOf(":");
        var property = content.slice(0, colonIndex);
        return property ? ARBITRARY_PROPERTY_PREFIX + property : void 0;
    }();
};
/**
* Exported for testing only
*/ var createClassMap = function(config) {
    var theme = config.theme, classGroups = config.classGroups;
    return processClassGroups(classGroups, theme);
};
var processClassGroups = function(classGroups, theme) {
    var classMap = createClassPartObject();
    for(var classGroupId in classGroups){
        var group = classGroups[classGroupId];
        processClassesRecursively(group, classMap, classGroupId, theme);
    }
    return classMap;
};
var processClassesRecursively = function(classGroup, classPartObject, classGroupId, theme) {
    var len = classGroup.length;
    for(var i = 0; i < len; i++){
        var classDefinition = classGroup[i];
        processClassDefinition(classDefinition, classPartObject, classGroupId, theme);
    }
};
var processClassDefinition = function(classDefinition, classPartObject, classGroupId, theme) {
    if (typeof classDefinition === "string") {
        processStringDefinition(classDefinition, classPartObject, classGroupId);
        return;
    }
    if (typeof classDefinition === "function") {
        processFunctionDefinition(classDefinition, classPartObject, classGroupId, theme);
        return;
    }
    processObjectDefinition(classDefinition, classPartObject, classGroupId, theme);
};
var processStringDefinition = function(classDefinition, classPartObject, classGroupId) {
    var classPartObjectToEdit = classDefinition === "" ? classPartObject : getPart(classPartObject, classDefinition);
    classPartObjectToEdit.classGroupId = classGroupId;
};
var processFunctionDefinition = function(classDefinition, classPartObject, classGroupId, theme) {
    if (isThemeGetter(classDefinition)) {
        processClassesRecursively(classDefinition(theme), classPartObject, classGroupId, theme);
        return;
    }
    if (classPartObject.validators === null) classPartObject.validators = [];
    classPartObject.validators.push(createClassValidatorObject(classGroupId, classDefinition));
};
var processObjectDefinition = function(classDefinition, classPartObject, classGroupId, theme) {
    var entries = Object.entries(classDefinition);
    var len = entries.length;
    for(var i = 0; i < len; i++){
        var _i = (0,_sliced_to_array/* default */.Z)(entries[i], 2), key = _i[0], value = _i[1];
        processClassesRecursively(value, getPart(classPartObject, key), classGroupId, theme);
    }
};
var getPart = function(classPartObject, path) {
    var current = classPartObject;
    var parts = path.split(CLASS_PART_SEPARATOR);
    var len = parts.length;
    for(var i = 0; i < len; i++){
        var part = parts[i];
        var next = current.nextPart.get(part);
        if (!next) {
            next = createClassPartObject();
            current.nextPart.set(part, next);
        }
        current = next;
    }
    return current;
};
var isThemeGetter = function(func) {
    return "isThemeGetter" in func && func.isThemeGetter === true;
};
var createLruCache = function(maxCacheSize) {
    if (maxCacheSize < 1) return {
        get: function() {
            return void 0;
        },
        set: function() {}
    };
    var cacheSize = 0;
    var cache = Object.create(null);
    var previousCache = Object.create(null);
    var update = function(key, value) {
        cache[key] = value;
        cacheSize++;
        if (cacheSize > maxCacheSize) {
            cacheSize = 0;
            previousCache = cache;
            cache = Object.create(null);
        }
    };
    return {
        get: function get(key) {
            var value = cache[key];
            if (value !== void 0) return value;
            if ((value = previousCache[key]) !== void 0) {
                update(key, value);
                return value;
            }
        },
        set: function set(key, value) {
            if (key in cache) cache[key] = value;
            else update(key, value);
        }
    };
};
var IMPORTANT_MODIFIER = "!";
var MODIFIER_SEPARATOR = ":";
var EMPTY_MODIFIERS = [];
var createResultObject = function(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition, isExternal) {
    return {
        modifiers: modifiers,
        hasImportantModifier: hasImportantModifier,
        baseClassName: baseClassName,
        maybePostfixModifierPosition: maybePostfixModifierPosition,
        isExternal: isExternal
    };
};
var createParseClassName = function(config) {
    var prefix = config.prefix, experimentalParseClassName = config.experimentalParseClassName;
    /**
	* Parse class name into parts.
	*
	* Inspired by `splitAtTopLevelOnly` used in Tailwind CSS
	* @see https://github.com/tailwindlabs/tailwindcss/blob/v3.2.2/src/util/splitAtTopLevelOnly.js
	*/ var parseClassName = function(className) {
        var modifiers = [];
        var bracketDepth = 0;
        var parenDepth = 0;
        var modifierStart = 0;
        var postfixModifierPosition;
        var len = className.length;
        for(var index = 0; index < len; index++){
            var currentCharacter = className[index];
            if (bracketDepth === 0 && parenDepth === 0) {
                if (currentCharacter === MODIFIER_SEPARATOR) {
                    modifiers.push(className.slice(modifierStart, index));
                    modifierStart = index + 1;
                    continue;
                }
                if (currentCharacter === "/") {
                    postfixModifierPosition = index;
                    continue;
                }
            }
            if (currentCharacter === "[") bracketDepth++;
            else if (currentCharacter === "]") bracketDepth--;
            else if (currentCharacter === "(") parenDepth++;
            else if (currentCharacter === ")") parenDepth--;
        }
        var baseClassNameWithImportantModifier = modifiers.length === 0 ? className : className.slice(modifierStart);
        var baseClassName = baseClassNameWithImportantModifier;
        var hasImportantModifier = false;
        if (baseClassNameWithImportantModifier.endsWith(IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(0, -1);
            hasImportantModifier = true;
        } else if (baseClassNameWithImportantModifier.startsWith(IMPORTANT_MODIFIER)) {
            baseClassName = baseClassNameWithImportantModifier.slice(1);
            hasImportantModifier = true;
        }
        var maybePostfixModifierPosition = postfixModifierPosition && postfixModifierPosition > modifierStart ? postfixModifierPosition - modifierStart : void 0;
        return createResultObject(modifiers, hasImportantModifier, baseClassName, maybePostfixModifierPosition);
    };
    if (prefix) {
        var fullPrefix = prefix + MODIFIER_SEPARATOR;
        var parseClassNameOriginal = parseClassName;
        parseClassName = function(className) {
            return className.startsWith(fullPrefix) ? parseClassNameOriginal(className.slice(fullPrefix.length)) : createResultObject(EMPTY_MODIFIERS, false, className, void 0, true);
        };
    }
    if (experimentalParseClassName) {
        var parseClassNameOriginal1 = parseClassName;
        parseClassName = function(className) {
            return experimentalParseClassName({
                className: className,
                parseClassName: parseClassNameOriginal1
            });
        };
    }
    return parseClassName;
};
/**
* Sorts modifiers according to following schema:
* - Predefined modifiers are sorted alphabetically
* - When an arbitrary variant appears, it must be preserved which modifiers are before and after it
*/ var createSortModifiers = function(config) {
    var modifierWeights = /* @__PURE__ */ new Map();
    config.orderSensitiveModifiers.forEach(function(mod, index) {
        modifierWeights.set(mod, 1e6 + index);
    });
    return function(modifiers) {
        var result = [];
        var currentSegment = [];
        for(var i = 0; i < modifiers.length; i++){
            var modifier = modifiers[i];
            var isArbitrary = modifier[0] === "[";
            var isOrderSensitive = modifierWeights.has(modifier);
            if (isArbitrary || isOrderSensitive) {
                if (currentSegment.length > 0) {
                    var _result;
                    currentSegment.sort();
                    (_result = result).push.apply(_result, (0,_to_consumable_array/* default */.Z)(currentSegment));
                    currentSegment = [];
                }
                result.push(modifier);
            } else currentSegment.push(modifier);
        }
        if (currentSegment.length > 0) {
            var _result1;
            currentSegment.sort();
            (_result1 = result).push.apply(_result1, (0,_to_consumable_array/* default */.Z)(currentSegment));
        }
        return result;
    };
};
var createConfigUtils = function(config) {
    return (0,_object_spread/* default */.Z)({
        cache: createLruCache(config.cacheSize),
        parseClassName: createParseClassName(config),
        sortModifiers: createSortModifiers(config),
        postfixLookupClassGroupIds: createPostfixLookupClassGroupIds(config)
    }, createClassGroupUtils(config));
};
var createPostfixLookupClassGroupIds = function(config) {
    var lookup = Object.create(null);
    var classGroupIds = config.postfixLookupClassGroups;
    if (classGroupIds) for(var i = 0; i < classGroupIds.length; i++)lookup[classGroupIds[i]] = true;
    return lookup;
};
var SPLIT_CLASSES_REGEX = /\s+/;
var mergeClassList = function(classList, configUtils) {
    var parseClassName = configUtils.parseClassName, getClassGroupId = configUtils.getClassGroupId, getConflictingClassGroupIds = configUtils.getConflictingClassGroupIds, sortModifiers = configUtils.sortModifiers, postfixLookupClassGroupIds = configUtils.postfixLookupClassGroupIds;
    /**
	* Set of classGroupIds in following format:
	* `{importantModifier}{variantModifiers}{classGroupId}`
	* @example 'float'
	* @example 'hover:focus:bg-color'
	* @example 'md:!pr'
	*/ var classGroupsInConflict = [];
    var classNames = classList.trim().split(SPLIT_CLASSES_REGEX);
    var result = "";
    for(var index = classNames.length - 1; index >= 0; index -= 1){
        var originalClassName = classNames[index];
        var ref = parseClassName(originalClassName), isExternal = ref.isExternal, modifiers = ref.modifiers, hasImportantModifier = ref.hasImportantModifier, baseClassName = ref.baseClassName, maybePostfixModifierPosition = ref.maybePostfixModifierPosition;
        if (isExternal) {
            result = originalClassName + (result.length > 0 ? " " + result : result);
            continue;
        }
        var hasPostfixModifier = !!maybePostfixModifierPosition;
        var classGroupId = void 0;
        if (hasPostfixModifier) {
            classGroupId = getClassGroupId(baseClassName.substring(0, maybePostfixModifierPosition));
            var classGroupIdWithPostfix = classGroupId && postfixLookupClassGroupIds[classGroupId] ? getClassGroupId(baseClassName) : void 0;
            if (classGroupIdWithPostfix && classGroupIdWithPostfix !== classGroupId) {
                classGroupId = classGroupIdWithPostfix;
                hasPostfixModifier = false;
            }
        } else classGroupId = getClassGroupId(baseClassName);
        if (!classGroupId) {
            if (!hasPostfixModifier) {
                result = originalClassName + (result.length > 0 ? " " + result : result);
                continue;
            }
            classGroupId = getClassGroupId(baseClassName);
            if (!classGroupId) {
                result = originalClassName + (result.length > 0 ? " " + result : result);
                continue;
            }
            hasPostfixModifier = false;
        }
        var variantModifier = modifiers.length === 0 ? "" : modifiers.length === 1 ? modifiers[0] : sortModifiers(modifiers).join(":");
        var modifierId = hasImportantModifier ? variantModifier + IMPORTANT_MODIFIER : variantModifier;
        var classId = modifierId + classGroupId;
        if (classGroupsInConflict.indexOf(classId) > -1) continue;
        classGroupsInConflict.push(classId);
        var conflictGroups = getConflictingClassGroupIds(classGroupId, hasPostfixModifier);
        for(var i = 0; i < conflictGroups.length; ++i){
            var group = conflictGroups[i];
            classGroupsInConflict.push(modifierId + group);
        }
        result = originalClassName + (result.length > 0 ? " " + result : result);
    }
    return result;
};
/**
* The code in this file is copied from https://github.com/lukeed/clsx and modified to suit the needs of tailwind-merge better.
*
* Specifically:
* - Runtime code from https://github.com/lukeed/clsx/blob/v1.2.1/src/index.js
* - TypeScript types from https://github.com/lukeed/clsx/blob/v1.2.1/clsx.d.ts
*
* Original code has MIT license: Copyright (c) Luke Edwards <luke.edwards05@gmail.com> (lukeed.com)
*/ var twJoin = function() {
    for(var _len = arguments.length, classLists = new Array(_len), _key = 0; _key < _len; _key++){
        classLists[_key] = arguments[_key];
    }
    var index = 0;
    var argument;
    var resolvedValue;
    var string = "";
    while(index < classLists.length)if (argument = classLists[index++]) {
        if (resolvedValue = toValue(argument)) {
            string && (string += " ");
            string += resolvedValue;
        }
    }
    return string;
};
var toValue = function(mix) {
    if (typeof mix === "string") return mix;
    var resolvedValue;
    var string = "";
    for(var k = 0; k < mix.length; k++)if (mix[k]) {
        if (resolvedValue = toValue(mix[k])) {
            string && (string += " ");
            string += resolvedValue;
        }
    }
    return string;
};
var createTailwindMerge = function(createConfigFirst) {
    for(var _len = arguments.length, createConfigRest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        createConfigRest[_key - 1] = arguments[_key];
    }
    var configUtils;
    var cacheGet;
    var cacheSet;
    var functionToCall;
    var initTailwindMerge = function(classList) {
        configUtils = createConfigUtils(createConfigRest.reduce(function(previousConfig, createConfigCurrent) {
            return createConfigCurrent(previousConfig);
        }, createConfigFirst()));
        cacheGet = configUtils.cache.get;
        cacheSet = configUtils.cache.set;
        functionToCall = tailwindMerge;
        return tailwindMerge(classList);
    };
    var tailwindMerge = function(classList) {
        var cachedResult = cacheGet(classList);
        if (cachedResult) return cachedResult;
        var result = mergeClassList(classList, configUtils);
        cacheSet(classList, result);
        return result;
    };
    functionToCall = initTailwindMerge;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return functionToCall(twJoin.apply(void 0, (0,_to_consumable_array/* default */.Z)(args)));
    };
};
var fallbackThemeArr = [];
var fromTheme = function(key) {
    var themeGetter = function(theme) {
        return theme[key] || fallbackThemeArr;
    };
    themeGetter.isThemeGetter = true;
    return themeGetter;
};
var arbitraryValueRegex = /^\[(?:(\w[\w-]*):)?(.+)\]$/i;
var arbitraryVariableRegex = /^\((?:(\w[\w-]*):)?(.+)\)$/i;
var fractionRegex = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/;
var tshirtUnitRegex = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/;
var lengthUnitRegex = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/;
var colorFunctionRegex = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/;
var shadowRegex = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/;
var imageRegex = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/;
var isFraction = function(value) {
    return fractionRegex.test(value);
};
var isNumber = function(value) {
    return !!value && !Number.isNaN(Number(value));
};
var isInteger = function(value) {
    return !!value && Number.isInteger(Number(value));
};
var isPercent = function(value) {
    return value.endsWith("%") && isNumber(value.slice(0, -1));
};
var isTshirtSize = function(value) {
    return tshirtUnitRegex.test(value);
};
var isAny = function() {
    return true;
};
var isLengthOnly = function(value) {
    return lengthUnitRegex.test(value) && !colorFunctionRegex.test(value);
};
var isNever = function() {
    return false;
};
var isShadow = function(value) {
    return shadowRegex.test(value);
};
var isImage = function(value) {
    return imageRegex.test(value);
};
var isAnyNonArbitrary = function(value) {
    return !isArbitraryValue(value) && !isArbitraryVariable(value);
};
var isNamedContainerQuery = function(value) {
    return value.startsWith("@container") && (value[10] === "/" && value[11] !== void 0 || value[11] === "s" && value[16] !== void 0 && value.startsWith("-size/", 10) || value[11] === "n" && value[18] !== void 0 && value.startsWith("-normal/", 10));
};
var isArbitrarySize = function(value) {
    return getIsArbitraryValue(value, isLabelSize, isNever);
};
var isArbitraryValue = function(value) {
    return arbitraryValueRegex.test(value);
};
var isArbitraryLength = function(value) {
    return getIsArbitraryValue(value, isLabelLength, isLengthOnly);
};
var isArbitraryNumber = function(value) {
    return getIsArbitraryValue(value, isLabelNumber, isNumber);
};
var isArbitraryWeight = function(value) {
    return getIsArbitraryValue(value, isLabelWeight, isAny);
};
var isArbitraryFamilyName = function(value) {
    return getIsArbitraryValue(value, isLabelFamilyName, isNever);
};
var isArbitraryPosition = function(value) {
    return getIsArbitraryValue(value, isLabelPosition, isNever);
};
var isArbitraryImage = function(value) {
    return getIsArbitraryValue(value, isLabelImage, isImage);
};
var isArbitraryShadow = function(value) {
    return getIsArbitraryValue(value, isLabelShadow, isShadow);
};
var isArbitraryVariable = function(value) {
    return arbitraryVariableRegex.test(value);
};
var isArbitraryVariableLength = function(value) {
    return getIsArbitraryVariable(value, isLabelLength);
};
var isArbitraryVariableFamilyName = function(value) {
    return getIsArbitraryVariable(value, isLabelFamilyName);
};
var isArbitraryVariablePosition = function(value) {
    return getIsArbitraryVariable(value, isLabelPosition);
};
var isArbitraryVariableSize = function(value) {
    return getIsArbitraryVariable(value, isLabelSize);
};
var isArbitraryVariableImage = function(value) {
    return getIsArbitraryVariable(value, isLabelImage);
};
var isArbitraryVariableShadow = function(value) {
    return getIsArbitraryVariable(value, isLabelShadow, true);
};
var isArbitraryVariableWeight = function(value) {
    return getIsArbitraryVariable(value, isLabelWeight, true);
};
var getIsArbitraryValue = function(value, testLabel, testValue) {
    var result = arbitraryValueRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return testValue(result[2]);
    }
    return false;
};
var getIsArbitraryVariable = function(value, testLabel) {
    var shouldMatchNoLabel = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var result = arbitraryVariableRegex.exec(value);
    if (result) {
        if (result[1]) return testLabel(result[1]);
        return shouldMatchNoLabel;
    }
    return false;
};
var isLabelPosition = function(label) {
    return label === "position" || label === "percentage";
};
var isLabelImage = function(label) {
    return label === "image" || label === "url";
};
var isLabelSize = function(label) {
    return label === "length" || label === "size" || label === "bg-size";
};
var isLabelLength = function(label) {
    return label === "length";
};
var isLabelNumber = function(label) {
    return label === "number";
};
var isLabelFamilyName = function(label) {
    return label === "family-name";
};
var isLabelWeight = function(label) {
    return label === "number" || label === "weight";
};
var isLabelShadow = function(label) {
    return label === "shadow";
};
var getDefaultConfig = function() {
    /**
	* Theme getters for theme variable namespaces
	* @see https://tailwindcss.com/docs/theme#theme-variable-namespaces
	*/ var themeColor = fromTheme("color");
    var themeFont = fromTheme("font");
    var themeText = fromTheme("text");
    var themeFontWeight = fromTheme("font-weight");
    var themeTracking = fromTheme("tracking");
    var themeLeading = fromTheme("leading");
    var themeBreakpoint = fromTheme("breakpoint");
    var themeContainer = fromTheme("container");
    var themeSpacing = fromTheme("spacing");
    var themeRadius = fromTheme("radius");
    var themeShadow = fromTheme("shadow");
    var themeInsetShadow = fromTheme("inset-shadow");
    var themeTextShadow = fromTheme("text-shadow");
    var themeDropShadow = fromTheme("drop-shadow");
    var themeBlur = fromTheme("blur");
    var themePerspective = fromTheme("perspective");
    var themeAspect = fromTheme("aspect");
    var themeEase = fromTheme("ease");
    var themeAnimate = fromTheme("animate");
    /**
	* Helpers to avoid repeating the same scales
	*
	* We use functions that create a new array every time they're called instead of static arrays.
	* This ensures that users who modify any scale by mutating the array (e.g. with `array.push(element)`) don't accidentally mutate arrays in other parts of the config.
	*/ var scaleBreak = function() {
        return [
            "auto",
            "avoid",
            "all",
            "avoid-page",
            "page",
            "left",
            "right",
            "column"
        ];
    };
    var scalePosition = function() {
        return [
            "center",
            "top",
            "bottom",
            "left",
            "right",
            "top-left",
            "left-top",
            "top-right",
            "right-top",
            "bottom-right",
            "right-bottom",
            "bottom-left",
            "left-bottom"
        ];
    };
    var scalePositionWithArbitrary = function() {
        return (0,_to_consumable_array/* default */.Z)(scalePosition()).concat([
            isArbitraryVariable,
            isArbitraryValue
        ]);
    };
    var scaleOverflow = function() {
        return [
            "auto",
            "hidden",
            "clip",
            "visible",
            "scroll"
        ];
    };
    var scaleOverscroll = function() {
        return [
            "auto",
            "contain",
            "none"
        ];
    };
    var scaleUnambiguousSpacing = function() {
        return [
            isArbitraryVariable,
            isArbitraryValue,
            themeSpacing
        ];
    };
    var scaleInset = function() {
        return [
            isFraction,
            "full",
            "auto"
        ].concat((0,_to_consumable_array/* default */.Z)(scaleUnambiguousSpacing()));
    };
    var scaleGridTemplateColsRows = function() {
        return [
            isInteger,
            "none",
            "subgrid",
            isArbitraryVariable,
            isArbitraryValue
        ];
    };
    var scaleGridColRowStartAndEnd = function() {
        return [
            "auto",
            {
                span: [
                    "full",
                    isInteger,
                    isArbitraryVariable,
                    isArbitraryValue
                ]
            },
            isInteger,
            isArbitraryVariable,
            isArbitraryValue
        ];
    };
    var scaleGridColRowStartOrEnd = function() {
        return [
            isInteger,
            "auto",
            isArbitraryVariable,
            isArbitraryValue
        ];
    };
    var scaleGridAutoColsRows = function() {
        return [
            "auto",
            "min",
            "max",
            "fr",
            isArbitraryVariable,
            isArbitraryValue
        ];
    };
    var scaleAlignPrimaryAxis = function() {
        return [
            "start",
            "end",
            "center",
            "between",
            "around",
            "evenly",
            "stretch",
            "baseline",
            "center-safe",
            "end-safe"
        ];
    };
    var scaleAlignSecondaryAxis = function() {
        return [
            "start",
            "end",
            "center",
            "stretch",
            "center-safe",
            "end-safe"
        ];
    };
    var scaleMargin = function() {
        return [
            "auto"
        ].concat((0,_to_consumable_array/* default */.Z)(scaleUnambiguousSpacing()));
    };
    var scaleSizing = function() {
        return [
            isFraction,
            "auto",
            "full",
            "dvw",
            "dvh",
            "lvw",
            "lvh",
            "svw",
            "svh",
            "min",
            "max",
            "fit"
        ].concat((0,_to_consumable_array/* default */.Z)(scaleUnambiguousSpacing()));
    };
    var scaleSizingInline = function() {
        return [
            isFraction,
            "screen",
            "full",
            "dvw",
            "lvw",
            "svw",
            "min",
            "max",
            "fit"
        ].concat((0,_to_consumable_array/* default */.Z)(scaleUnambiguousSpacing()));
    };
    var scaleSizingBlock = function() {
        return [
            isFraction,
            "screen",
            "full",
            "lh",
            "dvh",
            "lvh",
            "svh",
            "min",
            "max",
            "fit"
        ].concat((0,_to_consumable_array/* default */.Z)(scaleUnambiguousSpacing()));
    };
    var scaleColor = function() {
        return [
            themeColor,
            isArbitraryVariable,
            isArbitraryValue
        ];
    };
    var scaleBgPosition = function() {
        return (0,_to_consumable_array/* default */.Z)(scalePosition()).concat([
            isArbitraryVariablePosition,
            isArbitraryPosition,
            {
                position: [
                    isArbitraryVariable,
                    isArbitraryValue
                ]
            }
        ]);
    };
    var scaleBgRepeat = function() {
        return [
            "no-repeat",
            {
                repeat: [
                    "",
                    "x",
                    "y",
                    "space",
                    "round"
                ]
            }
        ];
    };
    var scaleBgSize = function() {
        return [
            "auto",
            "cover",
            "contain",
            isArbitraryVariableSize,
            isArbitrarySize,
            {
                size: [
                    isArbitraryVariable,
                    isArbitraryValue
                ]
            }
        ];
    };
    var scaleGradientStopPosition = function() {
        return [
            isPercent,
            isArbitraryVariableLength,
            isArbitraryLength
        ];
    };
    var scaleRadius = function() {
        return [
            "",
            "none",
            "full",
            themeRadius,
            isArbitraryVariable,
            isArbitraryValue
        ];
    };
    var scaleBorderWidth = function() {
        return [
            "",
            isNumber,
            isArbitraryVariableLength,
            isArbitraryLength
        ];
    };
    var scaleLineStyle = function() {
        return [
            "solid",
            "dashed",
            "dotted",
            "double"
        ];
    };
    var scaleBlendMode = function() {
        return [
            "normal",
            "multiply",
            "screen",
            "overlay",
            "darken",
            "lighten",
            "color-dodge",
            "color-burn",
            "hard-light",
            "soft-light",
            "difference",
            "exclusion",
            "hue",
            "saturation",
            "color",
            "luminosity"
        ];
    };
    var scaleMaskImagePosition = function() {
        return [
            isNumber,
            isPercent,
            isArbitraryVariablePosition,
            isArbitraryPosition
        ];
    };
    var scaleBlur = function() {
        return [
            "",
            "none",
            themeBlur,
            isArbitraryVariable,
            isArbitraryValue
        ];
    };
    var scaleRotate = function() {
        return [
            "none",
            isNumber,
            isArbitraryVariable,
            isArbitraryValue
        ];
    };
    var scaleScale = function() {
        return [
            "none",
            isNumber,
            isArbitraryVariable,
            isArbitraryValue
        ];
    };
    var scaleSkew = function() {
        return [
            isNumber,
            isArbitraryVariable,
            isArbitraryValue
        ];
    };
    var scaleTranslate = function() {
        return [
            isFraction,
            "full"
        ].concat((0,_to_consumable_array/* default */.Z)(scaleUnambiguousSpacing()));
    };
    return {
        cacheSize: 500,
        theme: {
            animate: [
                "spin",
                "ping",
                "pulse",
                "bounce"
            ],
            aspect: [
                "video"
            ],
            blur: [
                isTshirtSize
            ],
            breakpoint: [
                isTshirtSize
            ],
            color: [
                isAny
            ],
            container: [
                isTshirtSize
            ],
            "drop-shadow": [
                isTshirtSize
            ],
            ease: [
                "in",
                "out",
                "in-out"
            ],
            font: [
                isAnyNonArbitrary
            ],
            "font-weight": [
                "thin",
                "extralight",
                "light",
                "normal",
                "medium",
                "semibold",
                "bold",
                "extrabold",
                "black"
            ],
            "inset-shadow": [
                isTshirtSize
            ],
            leading: [
                "none",
                "tight",
                "snug",
                "normal",
                "relaxed",
                "loose"
            ],
            perspective: [
                "dramatic",
                "near",
                "normal",
                "midrange",
                "distant",
                "none"
            ],
            radius: [
                isTshirtSize
            ],
            shadow: [
                isTshirtSize
            ],
            spacing: [
                "px",
                isNumber
            ],
            text: [
                isTshirtSize
            ],
            "text-shadow": [
                isTshirtSize
            ],
            tracking: [
                "tighter",
                "tight",
                "normal",
                "wide",
                "wider",
                "widest"
            ]
        },
        classGroups: {
            /**
			* Aspect Ratio
			* @see https://tailwindcss.com/docs/aspect-ratio
			*/ aspect: [
                {
                    aspect: [
                        "auto",
                        "square",
                        isFraction,
                        isArbitraryValue,
                        isArbitraryVariable,
                        themeAspect
                    ]
                }
            ],
            /**
			* Container
			* @see https://tailwindcss.com/docs/container
			* @deprecated since Tailwind CSS v4.0.0
			*/ container: [
                "container"
            ],
            /**
			* Container Type
			* @see https://tailwindcss.com/docs/responsive-design#container-queries
			*/ "container-type": [
                {
                    "@container": [
                        "",
                        "normal",
                        "size",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Container Name
			* @see https://tailwindcss.com/docs/responsive-design#named-containers
			*/ "container-named": [
                isNamedContainerQuery
            ],
            /**
			* Columns
			* @see https://tailwindcss.com/docs/columns
			*/ columns: [
                {
                    columns: [
                        isNumber,
                        isArbitraryValue,
                        isArbitraryVariable,
                        themeContainer
                    ]
                }
            ],
            /**
			* Break After
			* @see https://tailwindcss.com/docs/break-after
			*/ "break-after": [
                {
                    "break-after": scaleBreak()
                }
            ],
            /**
			* Break Before
			* @see https://tailwindcss.com/docs/break-before
			*/ "break-before": [
                {
                    "break-before": scaleBreak()
                }
            ],
            /**
			* Break Inside
			* @see https://tailwindcss.com/docs/break-inside
			*/ "break-inside": [
                {
                    "break-inside": [
                        "auto",
                        "avoid",
                        "avoid-page",
                        "avoid-column"
                    ]
                }
            ],
            /**
			* Box Decoration Break
			* @see https://tailwindcss.com/docs/box-decoration-break
			*/ "box-decoration": [
                {
                    "box-decoration": [
                        "slice",
                        "clone"
                    ]
                }
            ],
            /**
			* Box Sizing
			* @see https://tailwindcss.com/docs/box-sizing
			*/ box: [
                {
                    box: [
                        "border",
                        "content"
                    ]
                }
            ],
            /**
			* Display
			* @see https://tailwindcss.com/docs/display
			*/ display: [
                "block",
                "inline-block",
                "inline",
                "flex",
                "inline-flex",
                "table",
                "inline-table",
                "table-caption",
                "table-cell",
                "table-column",
                "table-column-group",
                "table-footer-group",
                "table-header-group",
                "table-row-group",
                "table-row",
                "flow-root",
                "grid",
                "inline-grid",
                "contents",
                "list-item",
                "hidden"
            ],
            /**
			* Screen Reader Only
			* @see https://tailwindcss.com/docs/display#screen-reader-only
			*/ sr: [
                "sr-only",
                "not-sr-only"
            ],
            /**
			* Floats
			* @see https://tailwindcss.com/docs/float
			*/ float: [
                {
                    float: [
                        "right",
                        "left",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
			* Clear
			* @see https://tailwindcss.com/docs/clear
			*/ clear: [
                {
                    clear: [
                        "left",
                        "right",
                        "both",
                        "none",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
			* Isolation
			* @see https://tailwindcss.com/docs/isolation
			*/ isolation: [
                "isolate",
                "isolation-auto"
            ],
            /**
			* Object Fit
			* @see https://tailwindcss.com/docs/object-fit
			*/ "object-fit": [
                {
                    object: [
                        "contain",
                        "cover",
                        "fill",
                        "none",
                        "scale-down"
                    ]
                }
            ],
            /**
			* Object Position
			* @see https://tailwindcss.com/docs/object-position
			*/ "object-position": [
                {
                    object: scalePositionWithArbitrary()
                }
            ],
            /**
			* Overflow
			* @see https://tailwindcss.com/docs/overflow
			*/ overflow: [
                {
                    overflow: scaleOverflow()
                }
            ],
            /**
			* Overflow X
			* @see https://tailwindcss.com/docs/overflow
			*/ "overflow-x": [
                {
                    "overflow-x": scaleOverflow()
                }
            ],
            /**
			* Overflow Y
			* @see https://tailwindcss.com/docs/overflow
			*/ "overflow-y": [
                {
                    "overflow-y": scaleOverflow()
                }
            ],
            /**
			* Overscroll Behavior
			* @see https://tailwindcss.com/docs/overscroll-behavior
			*/ overscroll: [
                {
                    overscroll: scaleOverscroll()
                }
            ],
            /**
			* Overscroll Behavior X
			* @see https://tailwindcss.com/docs/overscroll-behavior
			*/ "overscroll-x": [
                {
                    "overscroll-x": scaleOverscroll()
                }
            ],
            /**
			* Overscroll Behavior Y
			* @see https://tailwindcss.com/docs/overscroll-behavior
			*/ "overscroll-y": [
                {
                    "overscroll-y": scaleOverscroll()
                }
            ],
            /**
			* Position
			* @see https://tailwindcss.com/docs/position
			*/ position: [
                "static",
                "fixed",
                "absolute",
                "relative",
                "sticky"
            ],
            /**
			* Inset
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/ inset: [
                {
                    inset: scaleInset()
                }
            ],
            /**
			* Inset Inline
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/ "inset-x": [
                {
                    "inset-x": scaleInset()
                }
            ],
            /**
			* Inset Block
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/ "inset-y": [
                {
                    "inset-y": scaleInset()
                }
            ],
            /**
			* Inset Inline Start
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			* @todo class group will be renamed to `inset-s` in next major release
			*/ start: [
                {
                    "inset-s": scaleInset(),
                    /**
				* @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
				* @see https://github.com/tailwindlabs/tailwindcss/pull/19613
				*/ start: scaleInset()
                }
            ],
            /**
			* Inset Inline End
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			* @todo class group will be renamed to `inset-e` in next major release
			*/ end: [
                {
                    "inset-e": scaleInset(),
                    /**
				* @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
				* @see https://github.com/tailwindlabs/tailwindcss/pull/19613
				*/ end: scaleInset()
                }
            ],
            /**
			* Inset Block Start
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/ "inset-bs": [
                {
                    "inset-bs": scaleInset()
                }
            ],
            /**
			* Inset Block End
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/ "inset-be": [
                {
                    "inset-be": scaleInset()
                }
            ],
            /**
			* Top
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/ top: [
                {
                    top: scaleInset()
                }
            ],
            /**
			* Right
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/ right: [
                {
                    right: scaleInset()
                }
            ],
            /**
			* Bottom
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/ bottom: [
                {
                    bottom: scaleInset()
                }
            ],
            /**
			* Left
			* @see https://tailwindcss.com/docs/top-right-bottom-left
			*/ left: [
                {
                    left: scaleInset()
                }
            ],
            /**
			* Visibility
			* @see https://tailwindcss.com/docs/visibility
			*/ visibility: [
                "visible",
                "invisible",
                "collapse"
            ],
            /**
			* Z-Index
			* @see https://tailwindcss.com/docs/z-index
			*/ z: [
                {
                    z: [
                        isInteger,
                        "auto",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Flex Basis
			* @see https://tailwindcss.com/docs/flex-basis
			*/ basis: [
                {
                    basis: [
                        isFraction,
                        "full",
                        "auto",
                        themeContainer
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleUnambiguousSpacing()))
                }
            ],
            /**
			* Flex Direction
			* @see https://tailwindcss.com/docs/flex-direction
			*/ "flex-direction": [
                {
                    flex: [
                        "row",
                        "row-reverse",
                        "col",
                        "col-reverse"
                    ]
                }
            ],
            /**
			* Flex Wrap
			* @see https://tailwindcss.com/docs/flex-wrap
			*/ "flex-wrap": [
                {
                    flex: [
                        "nowrap",
                        "wrap",
                        "wrap-reverse"
                    ]
                }
            ],
            /**
			* Flex
			* @see https://tailwindcss.com/docs/flex
			*/ flex: [
                {
                    flex: [
                        isNumber,
                        isFraction,
                        "auto",
                        "initial",
                        "none",
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Flex Grow
			* @see https://tailwindcss.com/docs/flex-grow
			*/ grow: [
                {
                    grow: [
                        "",
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Flex Shrink
			* @see https://tailwindcss.com/docs/flex-shrink
			*/ shrink: [
                {
                    shrink: [
                        "",
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Order
			* @see https://tailwindcss.com/docs/order
			*/ order: [
                {
                    order: [
                        isInteger,
                        "first",
                        "last",
                        "none",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Grid Template Columns
			* @see https://tailwindcss.com/docs/grid-template-columns
			*/ "grid-cols": [
                {
                    "grid-cols": scaleGridTemplateColsRows()
                }
            ],
            /**
			* Grid Column Start / End
			* @see https://tailwindcss.com/docs/grid-column
			*/ "col-start-end": [
                {
                    col: scaleGridColRowStartAndEnd()
                }
            ],
            /**
			* Grid Column Start
			* @see https://tailwindcss.com/docs/grid-column
			*/ "col-start": [
                {
                    "col-start": scaleGridColRowStartOrEnd()
                }
            ],
            /**
			* Grid Column End
			* @see https://tailwindcss.com/docs/grid-column
			*/ "col-end": [
                {
                    "col-end": scaleGridColRowStartOrEnd()
                }
            ],
            /**
			* Grid Template Rows
			* @see https://tailwindcss.com/docs/grid-template-rows
			*/ "grid-rows": [
                {
                    "grid-rows": scaleGridTemplateColsRows()
                }
            ],
            /**
			* Grid Row Start / End
			* @see https://tailwindcss.com/docs/grid-row
			*/ "row-start-end": [
                {
                    row: scaleGridColRowStartAndEnd()
                }
            ],
            /**
			* Grid Row Start
			* @see https://tailwindcss.com/docs/grid-row
			*/ "row-start": [
                {
                    "row-start": scaleGridColRowStartOrEnd()
                }
            ],
            /**
			* Grid Row End
			* @see https://tailwindcss.com/docs/grid-row
			*/ "row-end": [
                {
                    "row-end": scaleGridColRowStartOrEnd()
                }
            ],
            /**
			* Grid Auto Flow
			* @see https://tailwindcss.com/docs/grid-auto-flow
			*/ "grid-flow": [
                {
                    "grid-flow": [
                        "row",
                        "col",
                        "dense",
                        "row-dense",
                        "col-dense"
                    ]
                }
            ],
            /**
			* Grid Auto Columns
			* @see https://tailwindcss.com/docs/grid-auto-columns
			*/ "auto-cols": [
                {
                    "auto-cols": scaleGridAutoColsRows()
                }
            ],
            /**
			* Grid Auto Rows
			* @see https://tailwindcss.com/docs/grid-auto-rows
			*/ "auto-rows": [
                {
                    "auto-rows": scaleGridAutoColsRows()
                }
            ],
            /**
			* Gap
			* @see https://tailwindcss.com/docs/gap
			*/ gap: [
                {
                    gap: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Gap X
			* @see https://tailwindcss.com/docs/gap
			*/ "gap-x": [
                {
                    "gap-x": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Gap Y
			* @see https://tailwindcss.com/docs/gap
			*/ "gap-y": [
                {
                    "gap-y": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Justify Content
			* @see https://tailwindcss.com/docs/justify-content
			*/ "justify-content": [
                {
                    justify: (0,_to_consumable_array/* default */.Z)(scaleAlignPrimaryAxis()).concat([
                        "normal"
                    ])
                }
            ],
            /**
			* Justify Items
			* @see https://tailwindcss.com/docs/justify-items
			*/ "justify-items": [
                {
                    "justify-items": (0,_to_consumable_array/* default */.Z)(scaleAlignSecondaryAxis()).concat([
                        "normal"
                    ])
                }
            ],
            /**
			* Justify Self
			* @see https://tailwindcss.com/docs/justify-self
			*/ "justify-self": [
                {
                    "justify-self": [
                        "auto"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleAlignSecondaryAxis()))
                }
            ],
            /**
			* Align Content
			* @see https://tailwindcss.com/docs/align-content
			*/ "align-content": [
                {
                    content: [
                        "normal"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleAlignPrimaryAxis()))
                }
            ],
            /**
			* Align Items
			* @see https://tailwindcss.com/docs/align-items
			*/ "align-items": [
                {
                    items: (0,_to_consumable_array/* default */.Z)(scaleAlignSecondaryAxis()).concat([
                        {
                            baseline: [
                                "",
                                "last"
                            ]
                        }
                    ])
                }
            ],
            /**
			* Align Self
			* @see https://tailwindcss.com/docs/align-self
			*/ "align-self": [
                {
                    self: [
                        "auto"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleAlignSecondaryAxis()), [
                        {
                            baseline: [
                                "",
                                "last"
                            ]
                        }
                    ])
                }
            ],
            /**
			* Place Content
			* @see https://tailwindcss.com/docs/place-content
			*/ "place-content": [
                {
                    "place-content": scaleAlignPrimaryAxis()
                }
            ],
            /**
			* Place Items
			* @see https://tailwindcss.com/docs/place-items
			*/ "place-items": [
                {
                    "place-items": (0,_to_consumable_array/* default */.Z)(scaleAlignSecondaryAxis()).concat([
                        "baseline"
                    ])
                }
            ],
            /**
			* Place Self
			* @see https://tailwindcss.com/docs/place-self
			*/ "place-self": [
                {
                    "place-self": [
                        "auto"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleAlignSecondaryAxis()))
                }
            ],
            /**
			* Padding
			* @see https://tailwindcss.com/docs/padding
			*/ p: [
                {
                    p: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Padding Inline
			* @see https://tailwindcss.com/docs/padding
			*/ px: [
                {
                    px: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Padding Block
			* @see https://tailwindcss.com/docs/padding
			*/ py: [
                {
                    py: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Padding Inline Start
			* @see https://tailwindcss.com/docs/padding
			*/ ps: [
                {
                    ps: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Padding Inline End
			* @see https://tailwindcss.com/docs/padding
			*/ pe: [
                {
                    pe: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Padding Block Start
			* @see https://tailwindcss.com/docs/padding
			*/ pbs: [
                {
                    pbs: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Padding Block End
			* @see https://tailwindcss.com/docs/padding
			*/ pbe: [
                {
                    pbe: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Padding Top
			* @see https://tailwindcss.com/docs/padding
			*/ pt: [
                {
                    pt: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Padding Right
			* @see https://tailwindcss.com/docs/padding
			*/ pr: [
                {
                    pr: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Padding Bottom
			* @see https://tailwindcss.com/docs/padding
			*/ pb: [
                {
                    pb: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Padding Left
			* @see https://tailwindcss.com/docs/padding
			*/ pl: [
                {
                    pl: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Margin
			* @see https://tailwindcss.com/docs/margin
			*/ m: [
                {
                    m: scaleMargin()
                }
            ],
            /**
			* Margin Inline
			* @see https://tailwindcss.com/docs/margin
			*/ mx: [
                {
                    mx: scaleMargin()
                }
            ],
            /**
			* Margin Block
			* @see https://tailwindcss.com/docs/margin
			*/ my: [
                {
                    my: scaleMargin()
                }
            ],
            /**
			* Margin Inline Start
			* @see https://tailwindcss.com/docs/margin
			*/ ms: [
                {
                    ms: scaleMargin()
                }
            ],
            /**
			* Margin Inline End
			* @see https://tailwindcss.com/docs/margin
			*/ me: [
                {
                    me: scaleMargin()
                }
            ],
            /**
			* Margin Block Start
			* @see https://tailwindcss.com/docs/margin
			*/ mbs: [
                {
                    mbs: scaleMargin()
                }
            ],
            /**
			* Margin Block End
			* @see https://tailwindcss.com/docs/margin
			*/ mbe: [
                {
                    mbe: scaleMargin()
                }
            ],
            /**
			* Margin Top
			* @see https://tailwindcss.com/docs/margin
			*/ mt: [
                {
                    mt: scaleMargin()
                }
            ],
            /**
			* Margin Right
			* @see https://tailwindcss.com/docs/margin
			*/ mr: [
                {
                    mr: scaleMargin()
                }
            ],
            /**
			* Margin Bottom
			* @see https://tailwindcss.com/docs/margin
			*/ mb: [
                {
                    mb: scaleMargin()
                }
            ],
            /**
			* Margin Left
			* @see https://tailwindcss.com/docs/margin
			*/ ml: [
                {
                    ml: scaleMargin()
                }
            ],
            /**
			* Space Between X
			* @see https://tailwindcss.com/docs/margin#adding-space-between-children
			*/ "space-x": [
                {
                    "space-x": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Space Between X Reverse
			* @see https://tailwindcss.com/docs/margin#adding-space-between-children
			*/ "space-x-reverse": [
                "space-x-reverse"
            ],
            /**
			* Space Between Y
			* @see https://tailwindcss.com/docs/margin#adding-space-between-children
			*/ "space-y": [
                {
                    "space-y": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Space Between Y Reverse
			* @see https://tailwindcss.com/docs/margin#adding-space-between-children
			*/ "space-y-reverse": [
                "space-y-reverse"
            ],
            /**
			* Size
			* @see https://tailwindcss.com/docs/width#setting-both-width-and-height
			*/ size: [
                {
                    size: scaleSizing()
                }
            ],
            /**
			* Inline Size
			* @see https://tailwindcss.com/docs/width
			*/ "inline-size": [
                {
                    inline: [
                        "auto"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizingInline()))
                }
            ],
            /**
			* Min-Inline Size
			* @see https://tailwindcss.com/docs/min-width
			*/ "min-inline-size": [
                {
                    "min-inline": [
                        "auto"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizingInline()))
                }
            ],
            /**
			* Max-Inline Size
			* @see https://tailwindcss.com/docs/max-width
			*/ "max-inline-size": [
                {
                    "max-inline": [
                        "none"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizingInline()))
                }
            ],
            /**
			* Block Size
			* @see https://tailwindcss.com/docs/height
			*/ "block-size": [
                {
                    block: [
                        "auto"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizingBlock()))
                }
            ],
            /**
			* Min-Block Size
			* @see https://tailwindcss.com/docs/min-height
			*/ "min-block-size": [
                {
                    "min-block": [
                        "auto"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizingBlock()))
                }
            ],
            /**
			* Max-Block Size
			* @see https://tailwindcss.com/docs/max-height
			*/ "max-block-size": [
                {
                    "max-block": [
                        "none"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizingBlock()))
                }
            ],
            /**
			* Width
			* @see https://tailwindcss.com/docs/width
			*/ w: [
                {
                    w: [
                        themeContainer,
                        "screen"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizing()))
                }
            ],
            /**
			* Min-Width
			* @see https://tailwindcss.com/docs/min-width
			*/ "min-w": [
                {
                    "min-w": [
                        themeContainer,
                        "screen",
                        "none"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizing()))
                }
            ],
            /**
			* Max-Width
			* @see https://tailwindcss.com/docs/max-width
			*/ "max-w": [
                {
                    "max-w": [
                        themeContainer,
                        "screen",
                        "none",
                        "prose",
                        {
                            screen: [
                                themeBreakpoint
                            ]
                        }
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizing()))
                }
            ],
            /**
			* Height
			* @see https://tailwindcss.com/docs/height
			*/ h: [
                {
                    h: [
                        "screen",
                        "lh"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizing()))
                }
            ],
            /**
			* Min-Height
			* @see https://tailwindcss.com/docs/min-height
			*/ "min-h": [
                {
                    "min-h": [
                        "screen",
                        "lh",
                        "none"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizing()))
                }
            ],
            /**
			* Max-Height
			* @see https://tailwindcss.com/docs/max-height
			*/ "max-h": [
                {
                    "max-h": [
                        "screen",
                        "lh"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleSizing()))
                }
            ],
            /**
			* Font Size
			* @see https://tailwindcss.com/docs/font-size
			*/ "font-size": [
                {
                    text: [
                        "base",
                        themeText,
                        isArbitraryVariableLength,
                        isArbitraryLength
                    ]
                }
            ],
            /**
			* Font Smoothing
			* @see https://tailwindcss.com/docs/font-smoothing
			*/ "font-smoothing": [
                "antialiased",
                "subpixel-antialiased"
            ],
            /**
			* Font Style
			* @see https://tailwindcss.com/docs/font-style
			*/ "font-style": [
                "italic",
                "not-italic"
            ],
            /**
			* Font Weight
			* @see https://tailwindcss.com/docs/font-weight
			*/ "font-weight": [
                {
                    font: [
                        themeFontWeight,
                        isArbitraryVariableWeight,
                        isArbitraryWeight
                    ]
                }
            ],
            /**
			* Font Stretch
			* @see https://tailwindcss.com/docs/font-stretch
			*/ "font-stretch": [
                {
                    "font-stretch": [
                        "ultra-condensed",
                        "extra-condensed",
                        "condensed",
                        "semi-condensed",
                        "normal",
                        "semi-expanded",
                        "expanded",
                        "extra-expanded",
                        "ultra-expanded",
                        isPercent,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Font Family
			* @see https://tailwindcss.com/docs/font-family
			*/ "font-family": [
                {
                    font: [
                        isArbitraryVariableFamilyName,
                        isArbitraryFamilyName,
                        themeFont
                    ]
                }
            ],
            /**
			* Font Feature Settings
			* @see https://tailwindcss.com/docs/font-feature-settings
			*/ "font-features": [
                {
                    "font-features": [
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/ "fvn-normal": [
                "normal-nums"
            ],
            /**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/ "fvn-ordinal": [
                "ordinal"
            ],
            /**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/ "fvn-slashed-zero": [
                "slashed-zero"
            ],
            /**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/ "fvn-figure": [
                "lining-nums",
                "oldstyle-nums"
            ],
            /**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/ "fvn-spacing": [
                "proportional-nums",
                "tabular-nums"
            ],
            /**
			* Font Variant Numeric
			* @see https://tailwindcss.com/docs/font-variant-numeric
			*/ "fvn-fraction": [
                "diagonal-fractions",
                "stacked-fractions"
            ],
            /**
			* Letter Spacing
			* @see https://tailwindcss.com/docs/letter-spacing
			*/ tracking: [
                {
                    tracking: [
                        themeTracking,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Line Clamp
			* @see https://tailwindcss.com/docs/line-clamp
			*/ "line-clamp": [
                {
                    "line-clamp": [
                        isNumber,
                        "none",
                        isArbitraryVariable,
                        isArbitraryNumber
                    ]
                }
            ],
            /**
			* Line Height
			* @see https://tailwindcss.com/docs/line-height
			*/ leading: [
                {
                    leading: [
                        themeLeading
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleUnambiguousSpacing()))
                }
            ],
            /**
			* List Style Image
			* @see https://tailwindcss.com/docs/list-style-image
			*/ "list-image": [
                {
                    "list-image": [
                        "none",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* List Style Position
			* @see https://tailwindcss.com/docs/list-style-position
			*/ "list-style-position": [
                {
                    list: [
                        "inside",
                        "outside"
                    ]
                }
            ],
            /**
			* List Style Type
			* @see https://tailwindcss.com/docs/list-style-type
			*/ "list-style-type": [
                {
                    list: [
                        "disc",
                        "decimal",
                        "none",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Text Alignment
			* @see https://tailwindcss.com/docs/text-align
			*/ "text-alignment": [
                {
                    text: [
                        "left",
                        "center",
                        "right",
                        "justify",
                        "start",
                        "end"
                    ]
                }
            ],
            /**
			* Placeholder Color
			* @deprecated since Tailwind CSS v3.0.0
			* @see https://v3.tailwindcss.com/docs/placeholder-color
			*/ "placeholder-color": [
                {
                    placeholder: scaleColor()
                }
            ],
            /**
			* Text Color
			* @see https://tailwindcss.com/docs/text-color
			*/ "text-color": [
                {
                    text: scaleColor()
                }
            ],
            /**
			* Text Decoration
			* @see https://tailwindcss.com/docs/text-decoration
			*/ "text-decoration": [
                "underline",
                "overline",
                "line-through",
                "no-underline"
            ],
            /**
			* Text Decoration Style
			* @see https://tailwindcss.com/docs/text-decoration-style
			*/ "text-decoration-style": [
                {
                    decoration: (0,_to_consumable_array/* default */.Z)(scaleLineStyle()).concat([
                        "wavy"
                    ])
                }
            ],
            /**
			* Text Decoration Thickness
			* @see https://tailwindcss.com/docs/text-decoration-thickness
			*/ "text-decoration-thickness": [
                {
                    decoration: [
                        isNumber,
                        "from-font",
                        "auto",
                        isArbitraryVariable,
                        isArbitraryLength
                    ]
                }
            ],
            /**
			* Text Decoration Color
			* @see https://tailwindcss.com/docs/text-decoration-color
			*/ "text-decoration-color": [
                {
                    decoration: scaleColor()
                }
            ],
            /**
			* Text Underline Offset
			* @see https://tailwindcss.com/docs/text-underline-offset
			*/ "underline-offset": [
                {
                    "underline-offset": [
                        isNumber,
                        "auto",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Text Transform
			* @see https://tailwindcss.com/docs/text-transform
			*/ "text-transform": [
                "uppercase",
                "lowercase",
                "capitalize",
                "normal-case"
            ],
            /**
			* Text Overflow
			* @see https://tailwindcss.com/docs/text-overflow
			*/ "text-overflow": [
                "truncate",
                "text-ellipsis",
                "text-clip"
            ],
            /**
			* Text Wrap
			* @see https://tailwindcss.com/docs/text-wrap
			*/ "text-wrap": [
                {
                    text: [
                        "wrap",
                        "nowrap",
                        "balance",
                        "pretty"
                    ]
                }
            ],
            /**
			* Text Indent
			* @see https://tailwindcss.com/docs/text-indent
			*/ indent: [
                {
                    indent: scaleUnambiguousSpacing()
                }
            ],
            /**
			* Tab Size
			* @see https://tailwindcss.com/docs/tab-size
			*/ "tab-size": [
                {
                    tab: [
                        isInteger,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Vertical Alignment
			* @see https://tailwindcss.com/docs/vertical-align
			*/ "vertical-align": [
                {
                    align: [
                        "baseline",
                        "top",
                        "middle",
                        "bottom",
                        "text-top",
                        "text-bottom",
                        "sub",
                        "super",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Whitespace
			* @see https://tailwindcss.com/docs/whitespace
			*/ whitespace: [
                {
                    whitespace: [
                        "normal",
                        "nowrap",
                        "pre",
                        "pre-line",
                        "pre-wrap",
                        "break-spaces"
                    ]
                }
            ],
            /**
			* Word Break
			* @see https://tailwindcss.com/docs/word-break
			*/ break: [
                {
                    break: [
                        "normal",
                        "words",
                        "all",
                        "keep"
                    ]
                }
            ],
            /**
			* Overflow Wrap
			* @see https://tailwindcss.com/docs/overflow-wrap
			*/ wrap: [
                {
                    wrap: [
                        "break-word",
                        "anywhere",
                        "normal"
                    ]
                }
            ],
            /**
			* Hyphens
			* @see https://tailwindcss.com/docs/hyphens
			*/ hyphens: [
                {
                    hyphens: [
                        "none",
                        "manual",
                        "auto"
                    ]
                }
            ],
            /**
			* Content
			* @see https://tailwindcss.com/docs/content
			*/ content: [
                {
                    content: [
                        "none",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Background Attachment
			* @see https://tailwindcss.com/docs/background-attachment
			*/ "bg-attachment": [
                {
                    bg: [
                        "fixed",
                        "local",
                        "scroll"
                    ]
                }
            ],
            /**
			* Background Clip
			* @see https://tailwindcss.com/docs/background-clip
			*/ "bg-clip": [
                {
                    "bg-clip": [
                        "border",
                        "padding",
                        "content",
                        "text"
                    ]
                }
            ],
            /**
			* Background Origin
			* @see https://tailwindcss.com/docs/background-origin
			*/ "bg-origin": [
                {
                    "bg-origin": [
                        "border",
                        "padding",
                        "content"
                    ]
                }
            ],
            /**
			* Background Position
			* @see https://tailwindcss.com/docs/background-position
			*/ "bg-position": [
                {
                    bg: scaleBgPosition()
                }
            ],
            /**
			* Background Repeat
			* @see https://tailwindcss.com/docs/background-repeat
			*/ "bg-repeat": [
                {
                    bg: scaleBgRepeat()
                }
            ],
            /**
			* Background Size
			* @see https://tailwindcss.com/docs/background-size
			*/ "bg-size": [
                {
                    bg: scaleBgSize()
                }
            ],
            /**
			* Background Image
			* @see https://tailwindcss.com/docs/background-image
			*/ "bg-image": [
                {
                    bg: [
                        "none",
                        {
                            linear: [
                                {
                                    to: [
                                        "t",
                                        "tr",
                                        "r",
                                        "br",
                                        "b",
                                        "bl",
                                        "l",
                                        "tl"
                                    ]
                                },
                                isInteger,
                                isArbitraryVariable,
                                isArbitraryValue
                            ],
                            radial: [
                                "",
                                isArbitraryVariable,
                                isArbitraryValue
                            ],
                            conic: [
                                isInteger,
                                isArbitraryVariable,
                                isArbitraryValue
                            ]
                        },
                        isArbitraryVariableImage,
                        isArbitraryImage
                    ]
                }
            ],
            /**
			* Background Color
			* @see https://tailwindcss.com/docs/background-color
			*/ "bg-color": [
                {
                    bg: scaleColor()
                }
            ],
            /**
			* Gradient Color Stops From Position
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/ "gradient-from-pos": [
                {
                    from: scaleGradientStopPosition()
                }
            ],
            /**
			* Gradient Color Stops Via Position
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/ "gradient-via-pos": [
                {
                    via: scaleGradientStopPosition()
                }
            ],
            /**
			* Gradient Color Stops To Position
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/ "gradient-to-pos": [
                {
                    to: scaleGradientStopPosition()
                }
            ],
            /**
			* Gradient Color Stops From
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/ "gradient-from": [
                {
                    from: scaleColor()
                }
            ],
            /**
			* Gradient Color Stops Via
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/ "gradient-via": [
                {
                    via: scaleColor()
                }
            ],
            /**
			* Gradient Color Stops To
			* @see https://tailwindcss.com/docs/gradient-color-stops
			*/ "gradient-to": [
                {
                    to: scaleColor()
                }
            ],
            /**
			* Border Radius
			* @see https://tailwindcss.com/docs/border-radius
			*/ rounded: [
                {
                    rounded: scaleRadius()
                }
            ],
            /**
			* Border Radius Start
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-s": [
                {
                    "rounded-s": scaleRadius()
                }
            ],
            /**
			* Border Radius End
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-e": [
                {
                    "rounded-e": scaleRadius()
                }
            ],
            /**
			* Border Radius Top
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-t": [
                {
                    "rounded-t": scaleRadius()
                }
            ],
            /**
			* Border Radius Right
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-r": [
                {
                    "rounded-r": scaleRadius()
                }
            ],
            /**
			* Border Radius Bottom
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-b": [
                {
                    "rounded-b": scaleRadius()
                }
            ],
            /**
			* Border Radius Left
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-l": [
                {
                    "rounded-l": scaleRadius()
                }
            ],
            /**
			* Border Radius Start Start
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-ss": [
                {
                    "rounded-ss": scaleRadius()
                }
            ],
            /**
			* Border Radius Start End
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-se": [
                {
                    "rounded-se": scaleRadius()
                }
            ],
            /**
			* Border Radius End End
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-ee": [
                {
                    "rounded-ee": scaleRadius()
                }
            ],
            /**
			* Border Radius End Start
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-es": [
                {
                    "rounded-es": scaleRadius()
                }
            ],
            /**
			* Border Radius Top Left
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-tl": [
                {
                    "rounded-tl": scaleRadius()
                }
            ],
            /**
			* Border Radius Top Right
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-tr": [
                {
                    "rounded-tr": scaleRadius()
                }
            ],
            /**
			* Border Radius Bottom Right
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-br": [
                {
                    "rounded-br": scaleRadius()
                }
            ],
            /**
			* Border Radius Bottom Left
			* @see https://tailwindcss.com/docs/border-radius
			*/ "rounded-bl": [
                {
                    "rounded-bl": scaleRadius()
                }
            ],
            /**
			* Border Width
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w": [
                {
                    border: scaleBorderWidth()
                }
            ],
            /**
			* Border Width Inline
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w-x": [
                {
                    "border-x": scaleBorderWidth()
                }
            ],
            /**
			* Border Width Block
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w-y": [
                {
                    "border-y": scaleBorderWidth()
                }
            ],
            /**
			* Border Width Inline Start
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w-s": [
                {
                    "border-s": scaleBorderWidth()
                }
            ],
            /**
			* Border Width Inline End
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w-e": [
                {
                    "border-e": scaleBorderWidth()
                }
            ],
            /**
			* Border Width Block Start
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w-bs": [
                {
                    "border-bs": scaleBorderWidth()
                }
            ],
            /**
			* Border Width Block End
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w-be": [
                {
                    "border-be": scaleBorderWidth()
                }
            ],
            /**
			* Border Width Top
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w-t": [
                {
                    "border-t": scaleBorderWidth()
                }
            ],
            /**
			* Border Width Right
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w-r": [
                {
                    "border-r": scaleBorderWidth()
                }
            ],
            /**
			* Border Width Bottom
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w-b": [
                {
                    "border-b": scaleBorderWidth()
                }
            ],
            /**
			* Border Width Left
			* @see https://tailwindcss.com/docs/border-width
			*/ "border-w-l": [
                {
                    "border-l": scaleBorderWidth()
                }
            ],
            /**
			* Divide Width X
			* @see https://tailwindcss.com/docs/border-width#between-children
			*/ "divide-x": [
                {
                    "divide-x": scaleBorderWidth()
                }
            ],
            /**
			* Divide Width X Reverse
			* @see https://tailwindcss.com/docs/border-width#between-children
			*/ "divide-x-reverse": [
                "divide-x-reverse"
            ],
            /**
			* Divide Width Y
			* @see https://tailwindcss.com/docs/border-width#between-children
			*/ "divide-y": [
                {
                    "divide-y": scaleBorderWidth()
                }
            ],
            /**
			* Divide Width Y Reverse
			* @see https://tailwindcss.com/docs/border-width#between-children
			*/ "divide-y-reverse": [
                "divide-y-reverse"
            ],
            /**
			* Border Style
			* @see https://tailwindcss.com/docs/border-style
			*/ "border-style": [
                {
                    border: (0,_to_consumable_array/* default */.Z)(scaleLineStyle()).concat([
                        "hidden",
                        "none"
                    ])
                }
            ],
            /**
			* Divide Style
			* @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
			*/ "divide-style": [
                {
                    divide: (0,_to_consumable_array/* default */.Z)(scaleLineStyle()).concat([
                        "hidden",
                        "none"
                    ])
                }
            ],
            /**
			* Border Color
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color": [
                {
                    border: scaleColor()
                }
            ],
            /**
			* Border Color Inline
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color-x": [
                {
                    "border-x": scaleColor()
                }
            ],
            /**
			* Border Color Block
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color-y": [
                {
                    "border-y": scaleColor()
                }
            ],
            /**
			* Border Color Inline Start
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color-s": [
                {
                    "border-s": scaleColor()
                }
            ],
            /**
			* Border Color Inline End
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color-e": [
                {
                    "border-e": scaleColor()
                }
            ],
            /**
			* Border Color Block Start
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color-bs": [
                {
                    "border-bs": scaleColor()
                }
            ],
            /**
			* Border Color Block End
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color-be": [
                {
                    "border-be": scaleColor()
                }
            ],
            /**
			* Border Color Top
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color-t": [
                {
                    "border-t": scaleColor()
                }
            ],
            /**
			* Border Color Right
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color-r": [
                {
                    "border-r": scaleColor()
                }
            ],
            /**
			* Border Color Bottom
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color-b": [
                {
                    "border-b": scaleColor()
                }
            ],
            /**
			* Border Color Left
			* @see https://tailwindcss.com/docs/border-color
			*/ "border-color-l": [
                {
                    "border-l": scaleColor()
                }
            ],
            /**
			* Divide Color
			* @see https://tailwindcss.com/docs/divide-color
			*/ "divide-color": [
                {
                    divide: scaleColor()
                }
            ],
            /**
			* Outline Style
			* @see https://tailwindcss.com/docs/outline-style
			*/ "outline-style": [
                {
                    outline: (0,_to_consumable_array/* default */.Z)(scaleLineStyle()).concat([
                        "none",
                        "hidden"
                    ])
                }
            ],
            /**
			* Outline Offset
			* @see https://tailwindcss.com/docs/outline-offset
			*/ "outline-offset": [
                {
                    "outline-offset": [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Outline Width
			* @see https://tailwindcss.com/docs/outline-width
			*/ "outline-w": [
                {
                    outline: [
                        "",
                        isNumber,
                        isArbitraryVariableLength,
                        isArbitraryLength
                    ]
                }
            ],
            /**
			* Outline Color
			* @see https://tailwindcss.com/docs/outline-color
			*/ "outline-color": [
                {
                    outline: scaleColor()
                }
            ],
            /**
			* Box Shadow
			* @see https://tailwindcss.com/docs/box-shadow
			*/ shadow: [
                {
                    shadow: [
                        "",
                        "none",
                        themeShadow,
                        isArbitraryVariableShadow,
                        isArbitraryShadow
                    ]
                }
            ],
            /**
			* Box Shadow Color
			* @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
			*/ "shadow-color": [
                {
                    shadow: scaleColor()
                }
            ],
            /**
			* Inset Box Shadow
			* @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
			*/ "inset-shadow": [
                {
                    "inset-shadow": [
                        "none",
                        themeInsetShadow,
                        isArbitraryVariableShadow,
                        isArbitraryShadow
                    ]
                }
            ],
            /**
			* Inset Box Shadow Color
			* @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
			*/ "inset-shadow-color": [
                {
                    "inset-shadow": scaleColor()
                }
            ],
            /**
			* Ring Width
			* @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
			*/ "ring-w": [
                {
                    ring: scaleBorderWidth()
                }
            ],
            /**
			* Ring Width Inset
			* @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
			* @deprecated since Tailwind CSS v4.0.0
			* @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
			*/ "ring-w-inset": [
                "ring-inset"
            ],
            /**
			* Ring Color
			* @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
			*/ "ring-color": [
                {
                    ring: scaleColor()
                }
            ],
            /**
			* Ring Offset Width
			* @see https://v3.tailwindcss.com/docs/ring-offset-width
			* @deprecated since Tailwind CSS v4.0.0
			* @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
			*/ "ring-offset-w": [
                {
                    "ring-offset": [
                        isNumber,
                        isArbitraryLength
                    ]
                }
            ],
            /**
			* Ring Offset Color
			* @see https://v3.tailwindcss.com/docs/ring-offset-color
			* @deprecated since Tailwind CSS v4.0.0
			* @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
			*/ "ring-offset-color": [
                {
                    "ring-offset": scaleColor()
                }
            ],
            /**
			* Inset Ring Width
			* @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
			*/ "inset-ring-w": [
                {
                    "inset-ring": scaleBorderWidth()
                }
            ],
            /**
			* Inset Ring Color
			* @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
			*/ "inset-ring-color": [
                {
                    "inset-ring": scaleColor()
                }
            ],
            /**
			* Text Shadow
			* @see https://tailwindcss.com/docs/text-shadow
			*/ "text-shadow": [
                {
                    "text-shadow": [
                        "none",
                        themeTextShadow,
                        isArbitraryVariableShadow,
                        isArbitraryShadow
                    ]
                }
            ],
            /**
			* Text Shadow Color
			* @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
			*/ "text-shadow-color": [
                {
                    "text-shadow": scaleColor()
                }
            ],
            /**
			* Opacity
			* @see https://tailwindcss.com/docs/opacity
			*/ opacity: [
                {
                    opacity: [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Mix Blend Mode
			* @see https://tailwindcss.com/docs/mix-blend-mode
			*/ "mix-blend": [
                {
                    "mix-blend": (0,_to_consumable_array/* default */.Z)(scaleBlendMode()).concat([
                        "plus-darker",
                        "plus-lighter"
                    ])
                }
            ],
            /**
			* Background Blend Mode
			* @see https://tailwindcss.com/docs/background-blend-mode
			*/ "bg-blend": [
                {
                    "bg-blend": scaleBlendMode()
                }
            ],
            /**
			* Mask Clip
			* @see https://tailwindcss.com/docs/mask-clip
			*/ "mask-clip": [
                {
                    "mask-clip": [
                        "border",
                        "padding",
                        "content",
                        "fill",
                        "stroke",
                        "view"
                    ]
                },
                "mask-no-clip"
            ],
            /**
			* Mask Composite
			* @see https://tailwindcss.com/docs/mask-composite
			*/ "mask-composite": [
                {
                    mask: [
                        "add",
                        "subtract",
                        "intersect",
                        "exclude"
                    ]
                }
            ],
            /**
			* Mask Image
			* @see https://tailwindcss.com/docs/mask-image
			*/ "mask-image-linear-pos": [
                {
                    "mask-linear": [
                        isNumber
                    ]
                }
            ],
            "mask-image-linear-from-pos": [
                {
                    "mask-linear-from": scaleMaskImagePosition()
                }
            ],
            "mask-image-linear-to-pos": [
                {
                    "mask-linear-to": scaleMaskImagePosition()
                }
            ],
            "mask-image-linear-from-color": [
                {
                    "mask-linear-from": scaleColor()
                }
            ],
            "mask-image-linear-to-color": [
                {
                    "mask-linear-to": scaleColor()
                }
            ],
            "mask-image-t-from-pos": [
                {
                    "mask-t-from": scaleMaskImagePosition()
                }
            ],
            "mask-image-t-to-pos": [
                {
                    "mask-t-to": scaleMaskImagePosition()
                }
            ],
            "mask-image-t-from-color": [
                {
                    "mask-t-from": scaleColor()
                }
            ],
            "mask-image-t-to-color": [
                {
                    "mask-t-to": scaleColor()
                }
            ],
            "mask-image-r-from-pos": [
                {
                    "mask-r-from": scaleMaskImagePosition()
                }
            ],
            "mask-image-r-to-pos": [
                {
                    "mask-r-to": scaleMaskImagePosition()
                }
            ],
            "mask-image-r-from-color": [
                {
                    "mask-r-from": scaleColor()
                }
            ],
            "mask-image-r-to-color": [
                {
                    "mask-r-to": scaleColor()
                }
            ],
            "mask-image-b-from-pos": [
                {
                    "mask-b-from": scaleMaskImagePosition()
                }
            ],
            "mask-image-b-to-pos": [
                {
                    "mask-b-to": scaleMaskImagePosition()
                }
            ],
            "mask-image-b-from-color": [
                {
                    "mask-b-from": scaleColor()
                }
            ],
            "mask-image-b-to-color": [
                {
                    "mask-b-to": scaleColor()
                }
            ],
            "mask-image-l-from-pos": [
                {
                    "mask-l-from": scaleMaskImagePosition()
                }
            ],
            "mask-image-l-to-pos": [
                {
                    "mask-l-to": scaleMaskImagePosition()
                }
            ],
            "mask-image-l-from-color": [
                {
                    "mask-l-from": scaleColor()
                }
            ],
            "mask-image-l-to-color": [
                {
                    "mask-l-to": scaleColor()
                }
            ],
            "mask-image-x-from-pos": [
                {
                    "mask-x-from": scaleMaskImagePosition()
                }
            ],
            "mask-image-x-to-pos": [
                {
                    "mask-x-to": scaleMaskImagePosition()
                }
            ],
            "mask-image-x-from-color": [
                {
                    "mask-x-from": scaleColor()
                }
            ],
            "mask-image-x-to-color": [
                {
                    "mask-x-to": scaleColor()
                }
            ],
            "mask-image-y-from-pos": [
                {
                    "mask-y-from": scaleMaskImagePosition()
                }
            ],
            "mask-image-y-to-pos": [
                {
                    "mask-y-to": scaleMaskImagePosition()
                }
            ],
            "mask-image-y-from-color": [
                {
                    "mask-y-from": scaleColor()
                }
            ],
            "mask-image-y-to-color": [
                {
                    "mask-y-to": scaleColor()
                }
            ],
            "mask-image-radial": [
                {
                    "mask-radial": [
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            "mask-image-radial-from-pos": [
                {
                    "mask-radial-from": scaleMaskImagePosition()
                }
            ],
            "mask-image-radial-to-pos": [
                {
                    "mask-radial-to": scaleMaskImagePosition()
                }
            ],
            "mask-image-radial-from-color": [
                {
                    "mask-radial-from": scaleColor()
                }
            ],
            "mask-image-radial-to-color": [
                {
                    "mask-radial-to": scaleColor()
                }
            ],
            "mask-image-radial-shape": [
                {
                    "mask-radial": [
                        "circle",
                        "ellipse"
                    ]
                }
            ],
            "mask-image-radial-size": [
                {
                    "mask-radial": [
                        {
                            closest: [
                                "side",
                                "corner"
                            ],
                            farthest: [
                                "side",
                                "corner"
                            ]
                        }
                    ]
                }
            ],
            "mask-image-radial-pos": [
                {
                    "mask-radial-at": scalePosition()
                }
            ],
            "mask-image-conic-pos": [
                {
                    "mask-conic": [
                        isNumber
                    ]
                }
            ],
            "mask-image-conic-from-pos": [
                {
                    "mask-conic-from": scaleMaskImagePosition()
                }
            ],
            "mask-image-conic-to-pos": [
                {
                    "mask-conic-to": scaleMaskImagePosition()
                }
            ],
            "mask-image-conic-from-color": [
                {
                    "mask-conic-from": scaleColor()
                }
            ],
            "mask-image-conic-to-color": [
                {
                    "mask-conic-to": scaleColor()
                }
            ],
            /**
			* Mask Mode
			* @see https://tailwindcss.com/docs/mask-mode
			*/ "mask-mode": [
                {
                    mask: [
                        "alpha",
                        "luminance",
                        "match"
                    ]
                }
            ],
            /**
			* Mask Origin
			* @see https://tailwindcss.com/docs/mask-origin
			*/ "mask-origin": [
                {
                    "mask-origin": [
                        "border",
                        "padding",
                        "content",
                        "fill",
                        "stroke",
                        "view"
                    ]
                }
            ],
            /**
			* Mask Position
			* @see https://tailwindcss.com/docs/mask-position
			*/ "mask-position": [
                {
                    mask: scaleBgPosition()
                }
            ],
            /**
			* Mask Repeat
			* @see https://tailwindcss.com/docs/mask-repeat
			*/ "mask-repeat": [
                {
                    mask: scaleBgRepeat()
                }
            ],
            /**
			* Mask Size
			* @see https://tailwindcss.com/docs/mask-size
			*/ "mask-size": [
                {
                    mask: scaleBgSize()
                }
            ],
            /**
			* Mask Type
			* @see https://tailwindcss.com/docs/mask-type
			*/ "mask-type": [
                {
                    "mask-type": [
                        "alpha",
                        "luminance"
                    ]
                }
            ],
            /**
			* Mask Image
			* @see https://tailwindcss.com/docs/mask-image
			*/ "mask-image": [
                {
                    mask: [
                        "none",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Filter
			* @see https://tailwindcss.com/docs/filter
			*/ filter: [
                {
                    filter: [
                        "",
                        "none",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Blur
			* @see https://tailwindcss.com/docs/blur
			*/ blur: [
                {
                    blur: scaleBlur()
                }
            ],
            /**
			* Brightness
			* @see https://tailwindcss.com/docs/brightness
			*/ brightness: [
                {
                    brightness: [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Contrast
			* @see https://tailwindcss.com/docs/contrast
			*/ contrast: [
                {
                    contrast: [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Drop Shadow
			* @see https://tailwindcss.com/docs/drop-shadow
			*/ "drop-shadow": [
                {
                    "drop-shadow": [
                        "",
                        "none",
                        themeDropShadow,
                        isArbitraryVariableShadow,
                        isArbitraryShadow
                    ]
                }
            ],
            /**
			* Drop Shadow Color
			* @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
			*/ "drop-shadow-color": [
                {
                    "drop-shadow": scaleColor()
                }
            ],
            /**
			* Grayscale
			* @see https://tailwindcss.com/docs/grayscale
			*/ grayscale: [
                {
                    grayscale: [
                        "",
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Hue Rotate
			* @see https://tailwindcss.com/docs/hue-rotate
			*/ "hue-rotate": [
                {
                    "hue-rotate": [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Invert
			* @see https://tailwindcss.com/docs/invert
			*/ invert: [
                {
                    invert: [
                        "",
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Saturate
			* @see https://tailwindcss.com/docs/saturate
			*/ saturate: [
                {
                    saturate: [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Sepia
			* @see https://tailwindcss.com/docs/sepia
			*/ sepia: [
                {
                    sepia: [
                        "",
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Backdrop Filter
			* @see https://tailwindcss.com/docs/backdrop-filter
			*/ "backdrop-filter": [
                {
                    "backdrop-filter": [
                        "",
                        "none",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Backdrop Blur
			* @see https://tailwindcss.com/docs/backdrop-blur
			*/ "backdrop-blur": [
                {
                    "backdrop-blur": scaleBlur()
                }
            ],
            /**
			* Backdrop Brightness
			* @see https://tailwindcss.com/docs/backdrop-brightness
			*/ "backdrop-brightness": [
                {
                    "backdrop-brightness": [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Backdrop Contrast
			* @see https://tailwindcss.com/docs/backdrop-contrast
			*/ "backdrop-contrast": [
                {
                    "backdrop-contrast": [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Backdrop Grayscale
			* @see https://tailwindcss.com/docs/backdrop-grayscale
			*/ "backdrop-grayscale": [
                {
                    "backdrop-grayscale": [
                        "",
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Backdrop Hue Rotate
			* @see https://tailwindcss.com/docs/backdrop-hue-rotate
			*/ "backdrop-hue-rotate": [
                {
                    "backdrop-hue-rotate": [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Backdrop Invert
			* @see https://tailwindcss.com/docs/backdrop-invert
			*/ "backdrop-invert": [
                {
                    "backdrop-invert": [
                        "",
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Backdrop Opacity
			* @see https://tailwindcss.com/docs/backdrop-opacity
			*/ "backdrop-opacity": [
                {
                    "backdrop-opacity": [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Backdrop Saturate
			* @see https://tailwindcss.com/docs/backdrop-saturate
			*/ "backdrop-saturate": [
                {
                    "backdrop-saturate": [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Backdrop Sepia
			* @see https://tailwindcss.com/docs/backdrop-sepia
			*/ "backdrop-sepia": [
                {
                    "backdrop-sepia": [
                        "",
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Border Collapse
			* @see https://tailwindcss.com/docs/border-collapse
			*/ "border-collapse": [
                {
                    border: [
                        "collapse",
                        "separate"
                    ]
                }
            ],
            /**
			* Border Spacing
			* @see https://tailwindcss.com/docs/border-spacing
			*/ "border-spacing": [
                {
                    "border-spacing": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Border Spacing X
			* @see https://tailwindcss.com/docs/border-spacing
			*/ "border-spacing-x": [
                {
                    "border-spacing-x": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Border Spacing Y
			* @see https://tailwindcss.com/docs/border-spacing
			*/ "border-spacing-y": [
                {
                    "border-spacing-y": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Table Layout
			* @see https://tailwindcss.com/docs/table-layout
			*/ "table-layout": [
                {
                    table: [
                        "auto",
                        "fixed"
                    ]
                }
            ],
            /**
			* Caption Side
			* @see https://tailwindcss.com/docs/caption-side
			*/ caption: [
                {
                    caption: [
                        "top",
                        "bottom"
                    ]
                }
            ],
            /**
			* Transition Property
			* @see https://tailwindcss.com/docs/transition-property
			*/ transition: [
                {
                    transition: [
                        "",
                        "all",
                        "colors",
                        "opacity",
                        "shadow",
                        "transform",
                        "none",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Transition Behavior
			* @see https://tailwindcss.com/docs/transition-behavior
			*/ "transition-behavior": [
                {
                    transition: [
                        "normal",
                        "discrete"
                    ]
                }
            ],
            /**
			* Transition Duration
			* @see https://tailwindcss.com/docs/transition-duration
			*/ duration: [
                {
                    duration: [
                        isNumber,
                        "initial",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Transition Timing Function
			* @see https://tailwindcss.com/docs/transition-timing-function
			*/ ease: [
                {
                    ease: [
                        "linear",
                        "initial",
                        themeEase,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Transition Delay
			* @see https://tailwindcss.com/docs/transition-delay
			*/ delay: [
                {
                    delay: [
                        isNumber,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Animation
			* @see https://tailwindcss.com/docs/animation
			*/ animate: [
                {
                    animate: [
                        "none",
                        themeAnimate,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Backface Visibility
			* @see https://tailwindcss.com/docs/backface-visibility
			*/ backface: [
                {
                    backface: [
                        "hidden",
                        "visible"
                    ]
                }
            ],
            /**
			* Perspective
			* @see https://tailwindcss.com/docs/perspective
			*/ perspective: [
                {
                    perspective: [
                        themePerspective,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Perspective Origin
			* @see https://tailwindcss.com/docs/perspective-origin
			*/ "perspective-origin": [
                {
                    "perspective-origin": scalePositionWithArbitrary()
                }
            ],
            /**
			* Rotate
			* @see https://tailwindcss.com/docs/rotate
			*/ rotate: [
                {
                    rotate: scaleRotate()
                }
            ],
            /**
			* Rotate X
			* @see https://tailwindcss.com/docs/rotate
			*/ "rotate-x": [
                {
                    "rotate-x": scaleRotate()
                }
            ],
            /**
			* Rotate Y
			* @see https://tailwindcss.com/docs/rotate
			*/ "rotate-y": [
                {
                    "rotate-y": scaleRotate()
                }
            ],
            /**
			* Rotate Z
			* @see https://tailwindcss.com/docs/rotate
			*/ "rotate-z": [
                {
                    "rotate-z": scaleRotate()
                }
            ],
            /**
			* Scale
			* @see https://tailwindcss.com/docs/scale
			*/ scale: [
                {
                    scale: scaleScale()
                }
            ],
            /**
			* Scale X
			* @see https://tailwindcss.com/docs/scale
			*/ "scale-x": [
                {
                    "scale-x": scaleScale()
                }
            ],
            /**
			* Scale Y
			* @see https://tailwindcss.com/docs/scale
			*/ "scale-y": [
                {
                    "scale-y": scaleScale()
                }
            ],
            /**
			* Scale Z
			* @see https://tailwindcss.com/docs/scale
			*/ "scale-z": [
                {
                    "scale-z": scaleScale()
                }
            ],
            /**
			* Scale 3D
			* @see https://tailwindcss.com/docs/scale
			*/ "scale-3d": [
                "scale-3d"
            ],
            /**
			* Skew
			* @see https://tailwindcss.com/docs/skew
			*/ skew: [
                {
                    skew: scaleSkew()
                }
            ],
            /**
			* Skew X
			* @see https://tailwindcss.com/docs/skew
			*/ "skew-x": [
                {
                    "skew-x": scaleSkew()
                }
            ],
            /**
			* Skew Y
			* @see https://tailwindcss.com/docs/skew
			*/ "skew-y": [
                {
                    "skew-y": scaleSkew()
                }
            ],
            /**
			* Transform
			* @see https://tailwindcss.com/docs/transform
			*/ transform: [
                {
                    transform: [
                        isArbitraryVariable,
                        isArbitraryValue,
                        "",
                        "none",
                        "gpu",
                        "cpu"
                    ]
                }
            ],
            /**
			* Transform Origin
			* @see https://tailwindcss.com/docs/transform-origin
			*/ "transform-origin": [
                {
                    origin: scalePositionWithArbitrary()
                }
            ],
            /**
			* Transform Style
			* @see https://tailwindcss.com/docs/transform-style
			*/ "transform-style": [
                {
                    transform: [
                        "3d",
                        "flat"
                    ]
                }
            ],
            /**
			* Translate
			* @see https://tailwindcss.com/docs/translate
			*/ translate: [
                {
                    translate: scaleTranslate()
                }
            ],
            /**
			* Translate X
			* @see https://tailwindcss.com/docs/translate
			*/ "translate-x": [
                {
                    "translate-x": scaleTranslate()
                }
            ],
            /**
			* Translate Y
			* @see https://tailwindcss.com/docs/translate
			*/ "translate-y": [
                {
                    "translate-y": scaleTranslate()
                }
            ],
            /**
			* Translate Z
			* @see https://tailwindcss.com/docs/translate
			*/ "translate-z": [
                {
                    "translate-z": scaleTranslate()
                }
            ],
            /**
			* Translate None
			* @see https://tailwindcss.com/docs/translate
			*/ "translate-none": [
                "translate-none"
            ],
            /**
			* Zoom
			* @see https://tailwindcss.com/docs/zoom
			*/ zoom: [
                {
                    zoom: [
                        isInteger,
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Accent Color
			* @see https://tailwindcss.com/docs/accent-color
			*/ accent: [
                {
                    accent: scaleColor()
                }
            ],
            /**
			* Appearance
			* @see https://tailwindcss.com/docs/appearance
			*/ appearance: [
                {
                    appearance: [
                        "none",
                        "auto"
                    ]
                }
            ],
            /**
			* Caret Color
			* @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
			*/ "caret-color": [
                {
                    caret: scaleColor()
                }
            ],
            /**
			* Color Scheme
			* @see https://tailwindcss.com/docs/color-scheme
			*/ "color-scheme": [
                {
                    scheme: [
                        "normal",
                        "dark",
                        "light",
                        "light-dark",
                        "only-dark",
                        "only-light"
                    ]
                }
            ],
            /**
			* Cursor
			* @see https://tailwindcss.com/docs/cursor
			*/ cursor: [
                {
                    cursor: [
                        "auto",
                        "default",
                        "pointer",
                        "wait",
                        "text",
                        "move",
                        "help",
                        "not-allowed",
                        "none",
                        "context-menu",
                        "progress",
                        "cell",
                        "crosshair",
                        "vertical-text",
                        "alias",
                        "copy",
                        "no-drop",
                        "grab",
                        "grabbing",
                        "all-scroll",
                        "col-resize",
                        "row-resize",
                        "n-resize",
                        "e-resize",
                        "s-resize",
                        "w-resize",
                        "ne-resize",
                        "nw-resize",
                        "se-resize",
                        "sw-resize",
                        "ew-resize",
                        "ns-resize",
                        "nesw-resize",
                        "nwse-resize",
                        "zoom-in",
                        "zoom-out",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Field Sizing
			* @see https://tailwindcss.com/docs/field-sizing
			*/ "field-sizing": [
                {
                    "field-sizing": [
                        "fixed",
                        "content"
                    ]
                }
            ],
            /**
			* Pointer Events
			* @see https://tailwindcss.com/docs/pointer-events
			*/ "pointer-events": [
                {
                    "pointer-events": [
                        "auto",
                        "none"
                    ]
                }
            ],
            /**
			* Resize
			* @see https://tailwindcss.com/docs/resize
			*/ resize: [
                {
                    resize: [
                        "none",
                        "",
                        "y",
                        "x"
                    ]
                }
            ],
            /**
			* Scroll Behavior
			* @see https://tailwindcss.com/docs/scroll-behavior
			*/ "scroll-behavior": [
                {
                    scroll: [
                        "auto",
                        "smooth"
                    ]
                }
            ],
            /**
			* Scrollbar Thumb Color
			* @see https://tailwindcss.com/docs/scrollbar-color
			*/ "scrollbar-thumb-color": [
                {
                    "scrollbar-thumb": scaleColor()
                }
            ],
            /**
			* Scrollbar Track Color
			* @see https://tailwindcss.com/docs/scrollbar-color
			*/ "scrollbar-track-color": [
                {
                    "scrollbar-track": scaleColor()
                }
            ],
            /**
			* Scrollbar Gutter
			* @see https://tailwindcss.com/docs/scrollbar-gutter
			*/ "scrollbar-gutter": [
                {
                    "scrollbar-gutter": [
                        "auto",
                        "stable",
                        "both"
                    ]
                }
            ],
            /**
			* Scrollbar Width
			* @see https://tailwindcss.com/docs/scrollbar-width
			*/ "scrollbar-w": [
                {
                    scrollbar: [
                        "auto",
                        "thin",
                        "none"
                    ]
                }
            ],
            /**
			* Scroll Margin
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-m": [
                {
                    "scroll-m": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Margin Inline
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-mx": [
                {
                    "scroll-mx": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Margin Block
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-my": [
                {
                    "scroll-my": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Margin Inline Start
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-ms": [
                {
                    "scroll-ms": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Margin Inline End
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-me": [
                {
                    "scroll-me": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Margin Block Start
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-mbs": [
                {
                    "scroll-mbs": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Margin Block End
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-mbe": [
                {
                    "scroll-mbe": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Margin Top
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-mt": [
                {
                    "scroll-mt": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Margin Right
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-mr": [
                {
                    "scroll-mr": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Margin Bottom
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-mb": [
                {
                    "scroll-mb": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Margin Left
			* @see https://tailwindcss.com/docs/scroll-margin
			*/ "scroll-ml": [
                {
                    "scroll-ml": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-p": [
                {
                    "scroll-p": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding Inline
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-px": [
                {
                    "scroll-px": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding Block
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-py": [
                {
                    "scroll-py": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding Inline Start
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-ps": [
                {
                    "scroll-ps": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding Inline End
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-pe": [
                {
                    "scroll-pe": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding Block Start
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-pbs": [
                {
                    "scroll-pbs": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding Block End
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-pbe": [
                {
                    "scroll-pbe": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding Top
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-pt": [
                {
                    "scroll-pt": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding Right
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-pr": [
                {
                    "scroll-pr": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding Bottom
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-pb": [
                {
                    "scroll-pb": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Padding Left
			* @see https://tailwindcss.com/docs/scroll-padding
			*/ "scroll-pl": [
                {
                    "scroll-pl": scaleUnambiguousSpacing()
                }
            ],
            /**
			* Scroll Snap Align
			* @see https://tailwindcss.com/docs/scroll-snap-align
			*/ "snap-align": [
                {
                    snap: [
                        "start",
                        "end",
                        "center",
                        "align-none"
                    ]
                }
            ],
            /**
			* Scroll Snap Stop
			* @see https://tailwindcss.com/docs/scroll-snap-stop
			*/ "snap-stop": [
                {
                    snap: [
                        "normal",
                        "always"
                    ]
                }
            ],
            /**
			* Scroll Snap Type
			* @see https://tailwindcss.com/docs/scroll-snap-type
			*/ "snap-type": [
                {
                    snap: [
                        "none",
                        "x",
                        "y",
                        "both"
                    ]
                }
            ],
            /**
			* Scroll Snap Type Strictness
			* @see https://tailwindcss.com/docs/scroll-snap-type
			*/ "snap-strictness": [
                {
                    snap: [
                        "mandatory",
                        "proximity"
                    ]
                }
            ],
            /**
			* Touch Action
			* @see https://tailwindcss.com/docs/touch-action
			*/ touch: [
                {
                    touch: [
                        "auto",
                        "none",
                        "manipulation"
                    ]
                }
            ],
            /**
			* Touch Action X
			* @see https://tailwindcss.com/docs/touch-action
			*/ "touch-x": [
                {
                    "touch-pan": [
                        "x",
                        "left",
                        "right"
                    ]
                }
            ],
            /**
			* Touch Action Y
			* @see https://tailwindcss.com/docs/touch-action
			*/ "touch-y": [
                {
                    "touch-pan": [
                        "y",
                        "up",
                        "down"
                    ]
                }
            ],
            /**
			* Touch Action Pinch Zoom
			* @see https://tailwindcss.com/docs/touch-action
			*/ "touch-pz": [
                "touch-pinch-zoom"
            ],
            /**
			* User Select
			* @see https://tailwindcss.com/docs/user-select
			*/ select: [
                {
                    select: [
                        "none",
                        "text",
                        "all",
                        "auto"
                    ]
                }
            ],
            /**
			* Will Change
			* @see https://tailwindcss.com/docs/will-change
			*/ "will-change": [
                {
                    "will-change": [
                        "auto",
                        "scroll",
                        "contents",
                        "transform",
                        isArbitraryVariable,
                        isArbitraryValue
                    ]
                }
            ],
            /**
			* Fill
			* @see https://tailwindcss.com/docs/fill
			*/ fill: [
                {
                    fill: [
                        "none"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleColor()))
                }
            ],
            /**
			* Stroke Width
			* @see https://tailwindcss.com/docs/stroke-width
			*/ "stroke-w": [
                {
                    stroke: [
                        isNumber,
                        isArbitraryVariableLength,
                        isArbitraryLength,
                        isArbitraryNumber
                    ]
                }
            ],
            /**
			* Stroke
			* @see https://tailwindcss.com/docs/stroke
			*/ stroke: [
                {
                    stroke: [
                        "none"
                    ].concat((0,_to_consumable_array/* default */.Z)(scaleColor()))
                }
            ],
            /**
			* Forced Color Adjust
			* @see https://tailwindcss.com/docs/forced-color-adjust
			*/ "forced-color-adjust": [
                {
                    "forced-color-adjust": [
                        "auto",
                        "none"
                    ]
                }
            ]
        },
        conflictingClassGroups: {
            "container-named": [
                "container-type"
            ],
            overflow: [
                "overflow-x",
                "overflow-y"
            ],
            overscroll: [
                "overscroll-x",
                "overscroll-y"
            ],
            inset: [
                "inset-x",
                "inset-y",
                "inset-bs",
                "inset-be",
                "start",
                "end",
                "top",
                "right",
                "bottom",
                "left"
            ],
            "inset-x": [
                "right",
                "left"
            ],
            "inset-y": [
                "top",
                "bottom"
            ],
            flex: [
                "basis",
                "grow",
                "shrink"
            ],
            gap: [
                "gap-x",
                "gap-y"
            ],
            p: [
                "px",
                "py",
                "ps",
                "pe",
                "pbs",
                "pbe",
                "pt",
                "pr",
                "pb",
                "pl"
            ],
            px: [
                "pr",
                "pl"
            ],
            py: [
                "pt",
                "pb"
            ],
            m: [
                "mx",
                "my",
                "ms",
                "me",
                "mbs",
                "mbe",
                "mt",
                "mr",
                "mb",
                "ml"
            ],
            mx: [
                "mr",
                "ml"
            ],
            my: [
                "mt",
                "mb"
            ],
            size: [
                "w",
                "h"
            ],
            "font-size": [
                "leading"
            ],
            "fvn-normal": [
                "fvn-ordinal",
                "fvn-slashed-zero",
                "fvn-figure",
                "fvn-spacing",
                "fvn-fraction"
            ],
            "fvn-ordinal": [
                "fvn-normal"
            ],
            "fvn-slashed-zero": [
                "fvn-normal"
            ],
            "fvn-figure": [
                "fvn-normal"
            ],
            "fvn-spacing": [
                "fvn-normal"
            ],
            "fvn-fraction": [
                "fvn-normal"
            ],
            "line-clamp": [
                "display",
                "overflow"
            ],
            rounded: [
                "rounded-s",
                "rounded-e",
                "rounded-t",
                "rounded-r",
                "rounded-b",
                "rounded-l",
                "rounded-ss",
                "rounded-se",
                "rounded-ee",
                "rounded-es",
                "rounded-tl",
                "rounded-tr",
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-s": [
                "rounded-ss",
                "rounded-es"
            ],
            "rounded-e": [
                "rounded-se",
                "rounded-ee"
            ],
            "rounded-t": [
                "rounded-tl",
                "rounded-tr"
            ],
            "rounded-r": [
                "rounded-tr",
                "rounded-br"
            ],
            "rounded-b": [
                "rounded-br",
                "rounded-bl"
            ],
            "rounded-l": [
                "rounded-tl",
                "rounded-bl"
            ],
            "border-spacing": [
                "border-spacing-x",
                "border-spacing-y"
            ],
            "border-w": [
                "border-w-x",
                "border-w-y",
                "border-w-s",
                "border-w-e",
                "border-w-bs",
                "border-w-be",
                "border-w-t",
                "border-w-r",
                "border-w-b",
                "border-w-l"
            ],
            "border-w-x": [
                "border-w-r",
                "border-w-l"
            ],
            "border-w-y": [
                "border-w-t",
                "border-w-b"
            ],
            "border-color": [
                "border-color-x",
                "border-color-y",
                "border-color-s",
                "border-color-e",
                "border-color-bs",
                "border-color-be",
                "border-color-t",
                "border-color-r",
                "border-color-b",
                "border-color-l"
            ],
            "border-color-x": [
                "border-color-r",
                "border-color-l"
            ],
            "border-color-y": [
                "border-color-t",
                "border-color-b"
            ],
            translate: [
                "translate-x",
                "translate-y",
                "translate-none"
            ],
            "translate-none": [
                "translate",
                "translate-x",
                "translate-y",
                "translate-z"
            ],
            "scroll-m": [
                "scroll-mx",
                "scroll-my",
                "scroll-ms",
                "scroll-me",
                "scroll-mbs",
                "scroll-mbe",
                "scroll-mt",
                "scroll-mr",
                "scroll-mb",
                "scroll-ml"
            ],
            "scroll-mx": [
                "scroll-mr",
                "scroll-ml"
            ],
            "scroll-my": [
                "scroll-mt",
                "scroll-mb"
            ],
            "scroll-p": [
                "scroll-px",
                "scroll-py",
                "scroll-ps",
                "scroll-pe",
                "scroll-pbs",
                "scroll-pbe",
                "scroll-pt",
                "scroll-pr",
                "scroll-pb",
                "scroll-pl"
            ],
            "scroll-px": [
                "scroll-pr",
                "scroll-pl"
            ],
            "scroll-py": [
                "scroll-pt",
                "scroll-pb"
            ],
            touch: [
                "touch-x",
                "touch-y",
                "touch-pz"
            ],
            "touch-x": [
                "touch"
            ],
            "touch-y": [
                "touch"
            ],
            "touch-pz": [
                "touch"
            ]
        },
        conflictingClassGroupModifiers: {
            "font-size": [
                "leading"
            ]
        },
        postfixLookupClassGroups: [
            "container-type"
        ],
        orderSensitiveModifiers: [
            "*",
            "**",
            "after",
            "backdrop",
            "before",
            "details-content",
            "file",
            "first-letter",
            "first-line",
            "marker",
            "placeholder",
            "selection"
        ]
    };
};
/**
* @param baseConfig Config where other config will be merged into. This object will be mutated.
* @param configExtension Partial config to merge into the `baseConfig`.
*/ var mergeConfigs = function(baseConfig, param) {
    var cacheSize = param.cacheSize, prefix = param.prefix, experimentalParseClassName = param.experimentalParseClassName, _extend = param.extend, extend = _extend === void 0 ? {} : _extend, _override = param.override, override = _override === void 0 ? {} : _override;
    overrideProperty(baseConfig, "cacheSize", cacheSize);
    overrideProperty(baseConfig, "prefix", prefix);
    overrideProperty(baseConfig, "experimentalParseClassName", experimentalParseClassName);
    overrideConfigProperties(baseConfig.theme, override.theme);
    overrideConfigProperties(baseConfig.classGroups, override.classGroups);
    overrideConfigProperties(baseConfig.conflictingClassGroups, override.conflictingClassGroups);
    overrideConfigProperties(baseConfig.conflictingClassGroupModifiers, override.conflictingClassGroupModifiers);
    overrideProperty(baseConfig, "postfixLookupClassGroups", override.postfixLookupClassGroups);
    overrideProperty(baseConfig, "orderSensitiveModifiers", override.orderSensitiveModifiers);
    mergeConfigProperties(baseConfig.theme, extend.theme);
    mergeConfigProperties(baseConfig.classGroups, extend.classGroups);
    mergeConfigProperties(baseConfig.conflictingClassGroups, extend.conflictingClassGroups);
    mergeConfigProperties(baseConfig.conflictingClassGroupModifiers, extend.conflictingClassGroupModifiers);
    mergeArrayProperties(baseConfig, extend, "postfixLookupClassGroups");
    mergeArrayProperties(baseConfig, extend, "orderSensitiveModifiers");
    return baseConfig;
};
var overrideProperty = function(baseObject, overrideKey, overrideValue) {
    if (overrideValue !== void 0) baseObject[overrideKey] = overrideValue;
};
var overrideConfigProperties = function(baseObject, overrideObject) {
    if (overrideObject) for(var key in overrideObject)overrideProperty(baseObject, key, overrideObject[key]);
};
var mergeConfigProperties = function(baseObject, mergeObject) {
    if (mergeObject) for(var key in mergeObject)mergeArrayProperties(baseObject, mergeObject, key);
};
var mergeArrayProperties = function(baseObject, mergeObject, key) {
    var mergeValue = mergeObject[key];
    if (mergeValue !== void 0) baseObject[key] = baseObject[key] ? baseObject[key].concat(mergeValue) : mergeValue;
};
var extendTailwindMerge = function(configExtension) {
    for(var _len = arguments.length, createConfig = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        createConfig[_key - 1] = arguments[_key];
    }
    return typeof configExtension === "function" ? createTailwindMerge.apply(void 0, [
        getDefaultConfig,
        configExtension
    ].concat((0,_to_consumable_array/* default */.Z)(createConfig))) : createTailwindMerge.apply(void 0, [
        function() {
            return mergeConfigs(getDefaultConfig(), configExtension);
        }
    ].concat((0,_to_consumable_array/* default */.Z)(createConfig)));
};
//#endregion


;// CONCATENATED MODULE: ../atoms/lib/chunks/cn-dk9nmc4mhy1765ud.js
"use client";


//#endregion
//#region src/utils/cn.ts
/**
* Atoms typography utilities (`text-{family}-{size}`) come from the `--text-*`
* theme tokens. tailwind-merge's default config doesn't know these custom
* values, so its greedy `text-color` group swallows them — making
* `cn('text-od-content-primary', 'text-display-lg')` drop the color (the two
* land in the same conflict group). Registering them as explicit members of the
* `font-size` group keeps typography and text-color in separate groups: exact
* class matches are resolved before the `text-color` validator, so
* `text-display-lg` → font-size and `text-od-*` → text-color.
*
* The class list is generated from `THEME_CONFIG.typography` (the source of
* truth) by `pnpm generate:themes` → `styles/typography.generated.ts`, so it
* stays in sync with the ramp automatically.
*/ var twMerge = extendTailwindMerge({
    extend: {
        classGroups: {
            "font-size": [
                {
                    text: (0,_to_consumable_array/* default */.Z)([
                        "display-lg",
                        "display-md",
                        "display-sm",
                        "display-xs",
                        "header-lg",
                        "header-md",
                        "header-sm",
                        "subheader-lg",
                        "subheader-md",
                        "subheader-sm",
                        "subheader-xs",
                        "body-xl",
                        "body-lg",
                        "body-md",
                        "body-sm",
                        "label-xl",
                        "label-lg",
                        "label-md",
                        "label-sm"
                    ])
                }
            ]
        }
    }
});
function cn() {
    for(var _len = arguments.length, inputs = new Array(_len), _key = 0; _key < _len; _key++){
        inputs[_key] = arguments[_key];
    }
    return twMerge(clsx(inputs));
}
var toHex = function(n) {
    return n.toString(16).padStart(2, "0");
};
function safeRandomId() {
    var c = globalThis.crypto;
    if (c && typeof c.randomUUID === "function") return c.randomUUID();
    if (c && typeof c.getRandomValues === "function") {
        var bytes = new Uint8Array(16);
        c.getRandomValues(bytes);
        bytes[6] = bytes[6] & 15 | 64;
        bytes[8] = bytes[8] & 63 | 128;
        var hex = Array.from(bytes, toHex).join("");
        return "".concat(hex.slice(0, 8), "-").concat(hex.slice(8, 12), "-").concat(hex.slice(12, 16), "-").concat(hex.slice(16, 20), "-").concat(hex.slice(20));
    }
    return "r".concat(Math.random().toString(36).slice(2)).concat(Date.now().toString(36));
}
//#endregion



/***/ }),

/***/ 74637:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "n": function() { return /* binding */ useObservabilitySafe; },
/* harmony export */   "t": function() { return /* binding */ useImpressionRef; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(60947);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(92336);
/* harmony import */ var _atoms_provider_g2ndkvacik1ctkmd_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13206);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44194);
"use client";




//#region src/helpers/useObservabilitySafe.ts
var noop = function() {};
/**
* The fail-safe wrapper every instrumented component calls — never the context
* directly. Swallows transport errors so an app that never initialized
* observability doesn't crash.
*
* Defensive on two axes:
* - **Resolution:** a host that returns a malformed value (null / missing
*   method) falls back to no-op via `?.`. We deliberately do NOT wrap the hook
*   call itself in try/catch — `useObservability` may call hooks, and swallowing
*   a throw mid-hook-sequence would corrupt React's hook state (worse than a
*   clean error). A host hook that throws synchronously is its own
*   rules-of-hooks violation.
* - **Dispatch:** the inner call is wrapped so a throwing transport is swallowed.
*
* Identity is stable by design (the returned wrapper is memoized with `[]`), so
* components can list it in their own `useCallback` deps without busting
* memoization every render — host `useObservability` hooks commonly return a
* fresh function each render. To avoid the stale-closure tradeoff that a plain
* captured value would have, the wrapper dispatches through a ref that tracks
* the latest transport: if the host swaps it at runtime (e.g. consent
* revocation), already-mounted components immediately use the new one.
*/ function useObservabilitySafe() {
    var ref;
    var useObservability = (0,_atoms_provider_g2ndkvacik1ctkmd_js__WEBPACK_IMPORTED_MODULE_1__.n)().useObservability;
    var ref1;
    var hostTrack = (ref1 = (ref = useObservability()) === null || ref === void 0 ? void 0 : ref.trackJourneyEvent) !== null && ref1 !== void 0 ? ref1 : noop;
    var latestTrack = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(hostTrack);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        latestTrack.current = hostTrack;
    }, [
        hostTrack
    ]);
    var trackJourneyEvent = (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return function(categoryName, eventName, eventData, contextualData) {
            try {
                latestTrack.current(categoryName, eventName, eventData, contextualData);
            } catch (e) {}
        };
    }, []);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(function() {
        return {
            trackJourneyEvent: trackJourneyEvent
        };
    }, [
        trackJourneyEvent
    ]);
}
//#endregion
//#region src/helpers/use-impression-ref.ts
/**
* Returns a ref callback that fires a one-time `*ViewEvent` when the attached
* element first enters the viewport. Merge-free for callers: the consumer's
* ref is composed in, so a component passes the result straight to its element.
*
* Two properties matter:
* - **Bundle isolation.** `react-intersection-observer` is loaded via a dynamic
*   `import()` INSIDE the effect, so it sits in an on-demand chunk. A component
*   that merely offers view tracking never pulls rio into its static bundle, and
*   a consumer who leaves `active` false never loads it.
* - **No remount.** The observer attaches to the element the component already
*   renders (via the returned ref) — the element is never wrapped in Suspense or
*   cloned into a new subtree, so uncontrolled value, focus, caret, and scroll
*   are never disturbed.
*
* The observed element is tracked as state (not a ref) because the effect that
* sets up the observer depends on it — `setNode` runs from the ref callback at
* attach time, and the effect re-runs when the node changes.
*/ function useImpressionRef(active, analyticsName, eventName, consumerRef) {
    var inViewThreshold = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : 0;
    var trackJourneyEvent = useObservabilitySafe().trackJourneyEvent;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(null), node = ref[0], setNode = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (!active || !analyticsName || !node) return void 0;
        var cancelled = false;
        var unobserve;
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function() {
            var observe, error;
            return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_3__.__generator)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        return [
                            4,
                            __webpack_require__.e(/* import() */ 4037).then(__webpack_require__.bind(__webpack_require__, 74037))
                        ];
                    case 1:
                        observe = _state.sent().observe;
                        if (cancelled) return [
                            2
                        ];
                        unobserve = observe(node, function(inView) {
                            if (inView) {
                                trackJourneyEvent("platform", eventName, {
                                    targetName: analyticsName
                                });
                                unobserve === null || unobserve === void 0 ? void 0 : unobserve();
                            }
                        }, {
                            threshold: inViewThreshold
                        });
                        return [
                            3,
                            3
                        ];
                    case 2:
                        error = _state.sent();
                        if (false) {}
                        return [
                            3,
                            3
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
        return function() {
            cancelled = true;
            unobserve === null || unobserve === void 0 ? void 0 : unobserve();
        };
    }, [
        active,
        analyticsName,
        node,
        eventName,
        inViewThreshold,
        trackJourneyEvent
    ]);
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(function(element) {
        setNode(element);
        (0,_atoms_provider_g2ndkvacik1ctkmd_js__WEBPACK_IMPORTED_MODULE_1__.r)(consumerRef, element);
    }, [
        consumerRef
    ]);
}
//#endregion



/***/ }),

/***/ 33369:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "xu": function() { return /* binding */ Box; },
  "JX": function() { return /* binding */ Col; },
  "X2": function() { return /* binding */ Row; }
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(36690);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(93089);
// EXTERNAL MODULE: ../../node_modules/.pnpm/@swc+helpers@0.4.11/node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(59106);
// EXTERNAL MODULE: ../atoms/lib/chunks/use-impression-ref-k081rlv0dt8gci3d.js
var use_impression_ref_k081rlv0dt8gci3d = __webpack_require__(74637);
// EXTERNAL MODULE: ../atoms/lib/chunks/cn-dk9nmc4mhy1765ud.js + 1 modules
var cn_dk9nmc4mhy1765ud = __webpack_require__(27739);
// EXTERNAL MODULE: ../atoms/lib/chunks/link-provider-erp27xeaxlv7jgvb.js
var link_provider_erp27xeaxlv7jgvb = __webpack_require__(76366);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/index.js
var react = __webpack_require__(44194);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.3.1/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(31549);
;// CONCATENATED MODULE: ../atoms/lib/chunks/container-bmokyww153ys88nc.js
"use client";






//#region src/utils/container.tsx
var Container = /*#__PURE__*/ react.forwardRef(function(props, ref) {
    var renderLink = (0,link_provider_erp27xeaxlv7jgvb.n)();
    if (props.href !== void 0) {
        var children = props.children, external = props.external, _as = props.as, href = props.href, rest = (0,_object_without_properties/* default */.Z)(props, [
            "children",
            "external",
            "as",
            "href"
        ]);
        return renderLink((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            ref: ref,
            href: href,
            to: href
        }, external ? {
            target: "_blank",
            rel: "noopener noreferrer"
        } : {}, rest), {
            children: children
        }));
    }
    if (props.onClick) {
        var children1 = props.children, _as1 = props.as, _href = props.href, rest1 = (0,_object_without_properties/* default */.Z)(props, [
            "children",
            "as",
            "href"
        ]);
        return /* @__PURE__ */ (0,jsx_runtime.jsx)("button", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
            type: "button",
            ref: ref
        }, rest1), {
            children: children1
        }));
    }
    var tmp = props.as, Component = tmp === void 0 ? "div" : tmp, children2 = props.children, _onClick = props.onClick, _href1 = props.href, rest2 = (0,_object_without_properties/* default */.Z)(props, [
        "as",
        "children",
        "onClick",
        "href"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Component, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: ref
    }, rest2), {
        children: children2
    }));
});
Container.displayName = "Container";
//#endregion


;// CONCATENATED MODULE: ../atoms/lib/components/box.js
"use client";








//#region src/components/box/box.tsx
/**
* Flex container. Applies `flex` by default; pass `className` to extend
* or override (tailwind-merge resolves conflicts so user classes win).
*
* @example
* ```tsx
* <Box className="gap-2 items-center">…</Box>
* <Box as="nav" className="flex-col gap-4">…</Box>
* ```
*/ var Box = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var className = _param.className, children = _param.children, analyticsName = _param.analyticsName, trackImpression = _param.trackImpression, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className",
        "children",
        "analyticsName",
        "trackImpression"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Container, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        ref: (0,use_impression_ref_k081rlv0dt8gci3d.t)(Boolean(analyticsName && trackImpression), analyticsName, "boxViewEvent", ref),
        className: (0,cn_dk9nmc4mhy1765ud.t)("flex", className)
    }, props), {
        children: children
    }));
});
Box.displayName = "Box";
/**
* Convenience wrapper that renders a `<Box>` with `flex-row` applied.
* Accepts all the same props as Box; `className` can still override.
*
* @example
* ```tsx
* <Row className="gap-2 items-center">…</Row>
* ```
*/ var Row = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,cn_dk9nmc4mhy1765ud.t)("flex-row", className)
    }, props));
});
Row.displayName = "Row";
/**
* Convenience wrapper that renders a `<Box>` with `flex-col` applied.
* Accepts all the same props as Box; `className` can still override.
*
* @example
* ```tsx
* <Col className="gap-2">…</Col>
* ```
*/ var Col = /*#__PURE__*/ react.forwardRef(function(_param, ref) {
    var className = _param.className, props = (0,_object_without_properties/* default */.Z)(_param, [
        "className"
    ]);
    return /* @__PURE__ */ (0,jsx_runtime.jsx)(Box, (0,_object_spread/* default */.Z)({
        ref: ref,
        className: (0,cn_dk9nmc4mhy1765ud.t)("flex-col", className)
    }, props));
});
Col.displayName = "Col";
//#endregion



/***/ })

}]);